// CONFIGURATION
  // ---- Worker addresses -------------------------------------------------
  // Live is what every customer uses. Add ?bwenv=staging to the page address to point
  // YOUR browser at the staging Worker (remembered until you use ?bwenv=live).
  // Nothing about this is visible to customers.
  const WORKERS = {
    live:    "https://battery-rego-proxy.geelong-ee4.workers.dev/",
    staging: "https://battery-rego-proxy-staging.geelong-ee4.workers.dev/"
  };
  const BW_ENV = (() => {
    try {
      const asked = new URLSearchParams(window.location.search).get("bwenv");
      if (asked) localStorage.setItem("bwEnv", asked);
      return localStorage.getItem("bwEnv") === "staging" ? "staging" : "live";
    } catch (e) { return "live"; }
  })();
  const CLOUDFLARE_WORKER_URL = WORKERS[BW_ENV];
  if (BW_ENV !== "live") console.info("Battery finder: using the STAGING Worker");

  const DATA_PATH = "v3-data-8kz2";                       // must match DATA_PATH in the Worker (or its default)
  const YMM_DATA_URL = CLOUDFLARE_WORKER_URL + DATA_PATH;
  const PRODUCTS_URL = CLOUDFLARE_WORKER_URL + "products"; // live fitment code -> product handles
  const CONTACT_URL = "/pages/contact";                   // "Contact us" button on the results help banner
  const PHONE_NUMBER = "(03) 9661 8036";                  // shown when we have nothing to sell them
  const PHONE_LINK = "tel:0396618036";

  // Products are read straight from the theme: /collections/all/fitment-n70zz?view=fitment
  // (needs templates/collection.fitment.liquid and fitment:CODE tags on the products).
  // No API token, nothing to expire. Set to false to go back through the Worker instead.
  // Brand order for the "Recommended" sort. Matched against the product's Vendor, and
  // against the title as a fallback (some Hankooks are listed under the Battery Empire vendor).
  // Shops shown on each battery, in this order.
  //   match – any part of the location name in Shopify (Settings -> Locations), case doesn't matter
  //   label – the short name shown on the card; hovering shows Shopify's full name
  // A location that isn't listed here still shows, after these, under its own name.
  //   useOverall – tick this row whenever the battery is buyable at all. Use it for the
  //                 warehouse, which has no click & collect so Shopify never lists it.
  const STOCK_LOCATIONS = [
    { match: "Melton",    label: "Melton" },
    { match: "Geelong",   label: "Geelong" },
    { match: "Warehouse", label: "Online warehouse", useOverall: true },
  ];

  const BRAND_ORDER = ["Deltec", "Varta", "Hankook", "Neuton Power", "Delkor", "Supercharge",
                       "Bosch", "Exide", "Century", "Energizer", "AC Delco", "Optima"];

  const USE_THEME_FEED = true;
  const TAG_PREFIX = "fitment:";   // the tag you put on products, e.g. fitment:N70ZZ. "" if the tag is just the code.
  // Shopify has more than one way to ask for "the products carrying this tag", and which ones a
  // store answers changes over time - the old /collections/all/<tag> path stopped filtering on
  // 2 November 2026 and quietly returned the whole catalogue instead. So we ask each way in turn
  // and keep the first answer that really was filtered. The order is cheapest-and-most-likely
  // first; a working store only ever makes one request.
  // sort_by=best-selling lets us record how popular each battery is, for the "Most bought" sort
  const FEED_URLS = code => {
    const tag = TAG_PREFIX + code;
    return [
      `/search?type=product&view=fitment&q=${encodeURIComponent('tag:"' + tag + '"')}`,
      `/collections/all?view=fitment&sort_by=best-selling&filter.p.tag=${encodeURIComponent(tag)}`,
      `/collections/all/${shopifyHandle(tag)}?view=fitment&sort_by=best-selling`,
    ];
  };

  // Plate colours per state. accent = badge + border, text = plate lettering.
  // Plate colours per state: bg = plate background, text = lettering, accent = border/divider
  // The example plate is only a hint at the usual shape for that state. Nothing is validated
  // against it - personalised plates follow no pattern at all, and refusing one would turn
  // a paying customer away.
  const PLATE_THEMES = {
    ACT:   { bg: "#ffffff", text: "#203CA8", accent: "#203CA8", name: "Australian Capital Territory", placeholder: "E.G. YAB12C" },
    NSW:   { bg: "#E0D50C", text: "#111111", accent: "#111111", name: "New South Wales", placeholder: "E.G. AB12CD" },
    NT:    { bg: "#ffffff", text: "#C62D31", accent: "#C62D31", name: "Northern Territory", placeholder: "E.G. CA12BC" },
    QLD:   { bg: "#ffffff", text: "#8A223B", accent: "#8A223B", name: "Queensland", placeholder: "E.G. 123ABC" },
    SA:    { bg: "#ffffff", text: "#111111", accent: "#111111", name: "South Australia", placeholder: "E.G. S123ABC" },
    TAS:   { bg: "#ffffff", text: "#2F66BA", accent: "#2F66BA", name: "Tasmania", placeholder: "E.G. A12BC" },
    VIC:   { bg: "#ffffff", text: "#162662", accent: "#162662", name: "Victoria", placeholder: "E.G. ABC123" },
    WA:    { bg: "#ffffff", text: "#1E2AB5", accent: "#1E2AB5", name: "Western Australia", placeholder: "E.G. 1ABC234" },
    HEAVY: { bg: "#ffffff", text: "#111111", accent: "#111111", name: "National Heavy Vehicle", placeholder: "E.G. FB·23CA" }
  };



  // NEVDIS make names -> make names used in the YMM data
  // What the rego database calls a make  ->  what OUR guide calls it.
  // The guide's own names are the values; anything not listed here falls through
  // to the tolerant matching in resolveMakes() below.
  // Where the rego database uses an import's own name for a vehicle our guide files under
  // the Australian one. Additive: the rows under both names are considered, and the year and
  // engine decide. Only pairs that really are the same vehicle belong here.
  const MODEL_ALIASES = {
    "ESTIMA": ["Tarago"], "ESTIMA LUCIDA": ["Tarago"], "ESTIMA EMINA": ["Tarago"],
    "PREVIA": ["Tarago"],
  };

  const MAKE_ALIASES = {
    "MERCEDES-BENZ": ["Mercedes"], "MERCEDES BENZ": ["Mercedes"],
    "MERCEDES-AMG": ["Mercedes"], "MERCEDES AMG": ["Mercedes"], "AMG": ["Mercedes"],
    "LAND ROVER": ["Landrover", "Range Rover"], "LANDROVER": ["Landrover", "Range Rover"],
    "RANGE ROVER": ["Range Rover", "Landrover"],
    // Older rego records shorten the make: "L ROV", "M BENZ", "V/WAGEN"
    "L ROV": ["Landrover", "Range Rover"], "L/ROV": ["Landrover", "Range Rover"],
    "L ROVER": ["Landrover", "Range Rover"], "L/ROVER": ["Landrover", "Range Rover"],
    "LAND ROV": ["Landrover", "Range Rover"], "RANGE ROV": ["Range Rover", "Landrover"],
    "M BENZ": ["Mercedes"], "M/BENZ": ["Mercedes"], "MERC": ["Mercedes"],
    "V/WAGEN": ["Volkswagen"], "V WAGEN": ["Volkswagen"], "VOLKS": ["Volkswagen"],
    "HSV": ["Holden Special Vehicles"], "HOLDEN SPECIAL VEHICLES": ["Holden Special Vehicles"],
    "FPV": ["Ford Performance Vehicles"], "FORD PERFORMANCE VEHICLES": ["Ford Performance Vehicles"],
    // GWM sells Great Wall, Haval, Tank, Cannon and Ora under the one badge
    "GWM": ["Great Wall", "Haval"],
    "GWM HAVAL": ["Haval", "Great Wall"], "GWM ORA": ["Haval", "Great Wall"],
    "GREAT WALL MOTORS": ["Great Wall"], "GREAT WALL MOTOR": ["Great Wall"],
    "TANK": ["Great Wall"], "ORA": ["Haval", "Great Wall"],
    "ROLLS-ROYCE": ["Rolls Royce"],
    "CHEVROLET": ["Chevrolet", "Chev / GMC"], "GMC": ["Chev / GMC"], "CHEV": ["Chev / GMC", "Chevrolet"],
    "ISUZU UTE": ["Isuzu"], "ISUZU UTE AUSTRALIA": ["Isuzu"],
    "KGM": ["Ssangyong"], "KG MOBILITY": ["Ssangyong"], "SSANG YONG": ["Ssangyong"],
    "LDV": ["LDV"], "MAXUS": ["LDV"], "SAIC": ["LDV"], "SAIC MAXUS": ["LDV"],
    "VW": ["Volkswagen"], "VOLKSWAGEN COMMERCIAL": ["Volkswagen"], "VOLKSWAGEN COMMERCIAL VEHICLES": ["Volkswagen"],
    "SKODA": ["Skoda"], "ŠKODA": ["Skoda"],
    "CITROEN": ["Citroen"], "CITROËN": ["Citroen"],
    "ALFA": ["Alfa Romeo"],
    "OMODA": ["Chery"], "JAECOO": ["Chery"], "OMODA JAECOO": ["Chery"],
    "MG ROVER": ["MG", "Rover"], "MG MOTOR": ["MG"],
    // Badges our guide files as a model under the parent make
    "RAM": ["Dodge"], "RAM TRUCKS": ["Dodge"], "DODGE RAM": ["Dodge"],
    "INFINITI": ["Infiniti", "Nissan"],            // older Infinitis sit under Nissan
    "GENESIS": ["Genesis", "Hyundai"],             // the 2014-17 Genesis is a Hyundai here
    "MINI": ["Mini", "Leyland"],                   // the classic Mini is under Leyland
    "ALPINA": ["BMW"], "BMW ALPINA": ["BMW"],
    "BMW MINI": ["Mini"], "MINI COOPER": ["Mini"],
    "FIAT PROFESSIONAL": ["Fiat"],
    "JAGUAR DAIMLER": ["Jaguar", "Daimler"],
    "GENESIS MOTORS": ["Genesis", "Hyundai"]
  };

  // Suffixes the rego database bolts onto a make that our guide never uses
  const MAKE_NOISE = /\b(MOTOR|MOTORS|AUTOMOBILE|AUTOMOBILES|AUSTRALIA|AUSTRALIAN|AUST|GROUP|HOLDINGS?|UTE|COMMERCIAL|VEHICLE|VEHICLES|CARS?|PROFESSIONAL|CO|LTD|PTY|INC)\b/g;

  const VEHICLE_TYPE = "Car";          // cars only for now
  let makesList = [];                  // makes are loaded first; each make's vehicles are fetched when picked
  let portalAliases = {};              // "treat this make as…" rules, managed in the portal
  let portalModelAliases = {};         // the same for models, kept per make: { TOYOTA: { COROLA: ["Corolla"] } }
  let pendingNotes = [];               // warnings carried over when several variants share one battery
  let pendingLabel = "";               // the customer's own car, for the results heading
  let pendingModel = "";               // what the register called it, when we folded variants
  let pendingFitNote = "";             // "the same battery fits all of these"
  let pendingQty = 1;                  // how many batteries the guide says this vehicle carries

  /**
   * When several variants share one battery we show it without asking. Say so plainly,
   * naming the variants, so nobody thinks we guessed their engine. Where the names share
   * a common start ("F-Pace Diesel & Petrol 2.0 / 3.0 / 5.0") only the differences are
   * listed, because that's the bit a customer recognises.
   */
  function sameBatteryNote(matches) {
    const names = [...new Set(matches.map(m => m.model).filter(Boolean))];
    if (names.length < 2) return "";
    const split = n => n.trim().split(/\s+/);
    const first = split(names[0]);
    let common = 0;
    while (common < first.length - 1 &&
           names.every(n => { const w = split(n); return w.length > common + 1 && w[common].toLowerCase() === first[common].toLowerCase(); })) common++;
    const tails = names.map(n => split(n).slice(common).join(" ")).filter(Boolean);
    const list = arr => arr.length > 1 ? arr.slice(0, -1).join(", ") + " and " + arr[arr.length - 1] : arr[0];
    const shared = first.slice(0, common).join(" ");
    const useTails = common > 0 && tails.length === names.length && new Set(tails).size === names.length
                     && tails.every(t => t.length <= 24);
    return useTails
      ? `The same battery fits every ${shared} we list – ${list(tails)} – so there's nothing to choose between.`
      : `The same battery fits all of these: ${list(names)}.`;
  }
  let rowsByMake = {};                 // { "Toyota": [{ make, model, series, year, notes, fitmentCode }] }
  let dataReady = false;
  let regoOff = false, regoOffMessage = "";
  let finderOff = false;               // the master switch in Volt, for a fault in the finder itself
  let selectedValues = { make: "", model: "", year: "" };
  let optionsData = { make: [], model: [], year: [] };
  let highlightedIndices = { make: -1, model: -1, year: -1 };

  const RESULTS_PAGE_DEFAULT = "/pages/bf";
  const SEARCH_STATES = ["NSW", "VIC", "QLD", "SA", "WA", "TAS", "NT", "ACT"];

  function finderAttr(name) {
    const el = document.querySelector("[" + name + "]");
    return el ? String(el.getAttribute(name) || "").trim() : "";
  }

  // Staff mode only changes what this page is willing to SHOW. Whether the team notes exist
  // in the reply at all is decided by the Worker, against a code it keeps as a secret - so a
  // customer who finds this page, or sets the attribute by hand, still gets nothing.
  const STAFF_PAGE = finderAttr("data-staff").toLowerCase() === "true";

  let pendingTeamNotes = [];

  function showTeamNotes(notes) {
    let el = document.getElementById("bwr-team");
    const panel = document.getElementById("bwr-panel");
    if (!el) {
      if (!panel) return;
      const warn = document.getElementById("bwr-warn");
      el = document.createElement("div");
      el.id = "bwr-team";
      el.className = "bwr-team";
      panel.insertBefore(el, warn || panel.firstChild);
    }
    const list = (notes || []).filter(Boolean);
    if (!list.length) { el.style.display = "none"; el.innerHTML = ""; return; }
    el.style.display = "block";
    el.innerHTML = '<div class="bwr-team-head">Team notes <span>not shown to customers</span></div>' +
      '<ul class="bwr-team-list">' + list.map(n => "<li>" + escHtml(n) + "</li>").join("") + "</ul>";
  }

  function resultsPagePath() {
    const custom = finderAttr("data-results-url");
    return (custom || RESULTS_PAGE_DEFAULT).replace(/\/+$/, "") || RESULTS_PAGE_DEFAULT;
  }

  function herePath() {
    return String(window.location.pathname || "").replace(/\/+$/, "").toLowerCase();
  }

  function onResultsPage() {
    const here = herePath();
    const there = resultsPagePath().toLowerCase();
    return here === there || here.endsWith(there) || /\/bf$/.test(here);
  }

  function redirectMode() {
    return finderAttr("data-results").toLowerCase() === "redirect" && !onResultsPage();
  }

  function sendToResultsPage(params) {
    const target = resultsPagePath();
    if (target.toLowerCase() === herePath()) return false;
    const q = new URLSearchParams();
    Object.keys(params).forEach(k => { if (params[k]) q.set(k, params[k]); });
    const qs = q.toString();
    window.location.href = target + (qs ? "?" + qs : "");
    return true;
  }

  function dropSearchParams() {
    try {
      const url = new URL(window.location.href);
      ["rego", "state", "type", "make", "model", "year"].forEach(k => url.searchParams.delete(k));
      history.replaceState(history.state, "", url);
    } catch (e) {}
  }

  // Replaying a search from the portal. The token is swapped for what the rego lookup
  // returned at the time, then the normal matching runs on it - so what shows here is
  // exactly what the customer would see now.
  async function runReplayFromUrl(token) {
    replayMode = true;
    const regoTab = document.querySelectorAll(".bw-tab-link")[0];
    if (regoTab) openSearchTab({ currentTarget: regoTab }, "tab-rego");
    showWidgetMessage("Replaying that search…", "info");
    let data;
    try {
      const res = await fetch(CLOUDFLARE_WORKER_URL.replace(/\/+$/, "") + "/replay?t=" + encodeURIComponent(token), { cache: "no-store" });
      data = await res.json();
    } catch (err) {
      showWidgetMessage("Couldn't load that search. Please open it again from Volt.", "error");
      return;
    }
    if (!data.success) {
      showWidgetMessage(data.error === "replay_expired"
        ? "That replay link has expired. Open the search in Volt and press Replay again."
        : "Couldn't load that search. Please open it again from Volt.", "error");
      return;
    }

    setRegoGuide(data.guide);

    const input = document.getElementById("bw-rego-input");
    const sel = document.getElementById("bw-rego-state");
    if (input) input.value = data.rego || "";
    if (sel) {
      if (SEARCH_STATES.indexOf(data.state) > -1) { sel.value = data.state; applyPlateTheme(data.state); }
      else if (data.guide === "truck") { sel.value = "NHVR"; applyPlateTheme("NHVR"); }
    }

    hideWidgetMessage();
    showReplayBanner(data);
    await applyRegoResult(data.vehicle, null, data.rego || "", data.state || "");
  }

  function showReplayBanner(data) {
    const host = document.querySelector(".battery-widget-container") || document.body;
    let bar = document.getElementById("bw-replay-bar");
    if (!bar) {
      bar = document.createElement("div");
      bar.id = "bw-replay-bar";
      bar.className = "bw-replay-bar";
      host.insertBefore(bar, host.firstChild);
    }
    const when = String(data.at || "").slice(0, 16).replace(" ", " at ");
    const WAS = { matched: "found a battery", choose: "asked the customer to choose",
                  no_make: "didn't know the make", no_model: "didn't know the model",
                  not_a_car: "wasn't a car", failed: "failed", pending: "wasn't recorded" };
    const was = WAS[data.was] || data.was || "";
    bar.innerHTML = `<strong>Staff replay</strong> – ${escHtml([data.rego, data.state && "(" + data.state + ")"].filter(Boolean).join(" "))}${
      when ? ", searched " + escHtml(when) + " UTC" : ""}. Nothing was looked up again and this isn't recorded.${
      was ? ` At the time it <strong>${escHtml(was)}</strong>${data.wasModel ? ": " + escHtml(data.wasModel) : ""}${
        data.wasCode ? " · " + escHtml(data.wasCode) : ""}.` : ""}`;
  }

  function runSearchFromUrl() {
    if (finderOff) return;             // the widget has been replaced by the fault message
    let p;
    try { p = new URLSearchParams(window.location.search); } catch (e) { return; }
    if (p.get("fc")) return;

    const replay = String(p.get("replay") || "").trim();
    if (/^[a-f0-9]{32}$/.test(replay)) { runReplayFromUrl(replay); return; }

    const rego = String(p.get("rego") || "").trim().toUpperCase().replace(/[^A-Z0-9]/g, "");
    const state = String(p.get("state") || "").trim().toUpperCase();
    const type = String(p.get("type") || "car").trim().toLowerCase();
    const make = String(p.get("make") || "").trim();
    const model = String(p.get("model") || "").trim();
    const year = String(p.get("year") || "").trim();
    if (!rego && !make) return;
    if (type !== "car") return;

    dropSearchParams();

    if (rego) {
      const input = document.getElementById("bw-rego-input");
      const sel = document.getElementById("bw-rego-state");
      if (input) input.value = rego;
      if (sel && SEARCH_STATES.indexOf(state) > -1) { sel.value = state; applyPlateTheme(state); }
      const regoTab = document.querySelectorAll(".bw-tab-link")[0];
      if (regoTab) openSearchTab({ currentTarget: regoTab }, "tab-rego");
      submitRegoSearchInterim();
      return;
    }

    const realMake = makesList.find(m => normKey(m) === normKey(make));
    if (!realMake) return;
    ensureMakeRows(realMake).then(() => {
      const rows = rowsFor(realMake);
      const wanted = normKey(model);
      const hit = model ? rows.find(r => normKey(modelName(r)) === wanted || normKey(modelNameWithSeries(r)) === wanted || normKey(r.model) === wanted) : null;
      const realModel = hit ? modelName(hit) : "";
      const yearHit = year && realModel
        ? rows.find(r => rowIsModel(r, realModel) && normKey(r.year) === normKey(year))
        : null;
      prefillVehicleTab(realMake, realModel ? [realModel] : [], realModel || undefined,
                        yearHit ? yearHit.year : undefined);
    }).catch(() => {});
  }

  function bwInit() {
    const asked = finderAttr("data-results").toLowerCase();
    console.info("Battery finder: results " +
      (redirectMode() ? "redirect to " + resultsPagePath()
        : onResultsPage() ? "inline (this is the results page)"
        : asked ? "inline (data-results=\"" + asked + "\")"
        : "inline (no data-results attribute on the page)"));
    loadVehicleData().then(runSearchFromUrl).catch(() => {});
    // Remembered for this visit only. It used to be kept forever, which meant one customer
    // trying "Most bought" never saw our own brand order again on that browser.
    try {
      const s = sessionStorage.getItem("bwSort");
      if (s) sortMode = s;
      localStorage.removeItem("bwSort");
    } catch (e) {}
    if (getAccessCode() || STAFF_PAGE) showCodeLink();
    showStaffState();
    renderGarage();                            // saved vehicles from previous visits
    showResultsFromUrl();                      // shared links / back button restore the results
    const stateSel = document.getElementById("bw-rego-state");
    applyPlateTheme(stateSel ? stateSel.value : "VIC");
    document.addEventListener("click", (e) => {
      if (!e.target.closest(".bw-dd-wrapper")) closeAllDropdowns();
    });
  }


  /* ---------- access code (staff / trade – skips the daily limits) ---------- */
  function getAccessCode() {
    try {
      const fromUrl = new URLSearchParams(window.location.search).get("code");
      if (fromUrl) localStorage.setItem("bwAccessCode", fromUrl.trim());
      return (localStorage.getItem("bwAccessCode") || "").trim();
    } catch (e) { return ""; }
  }

  function setAccessCode(value) {
    try { value ? localStorage.setItem("bwAccessCode", value.trim()) : localStorage.removeItem("bwAccessCode"); } catch (e) {}
  }

  function withCode(url) {
    const code = getAccessCode();
    return code ? url + (url.includes("?") ? "&" : "?") + "code=" + encodeURIComponent(code) : url;
  }

  /**
   * The line on the staff page saying whether this device has a code. It reads the code
   * itself rather than being told, so it cannot drift out of step with reality - the first
   * version only refreshed on a click, and missed the Enter key entirely.
   */
  function showStaffState() {
    const el = document.getElementById("bw-staff-state");
    if (!el) return;
    el.innerHTML = getAccessCode()
      ? "<b>Staff code saved</b>"
      : "<i>No staff code on this device</i> &ndash; open <em>Have a trade code?</em> below";
  }

  // The trade code link only appears once someone hits the daily limit (or already has a code saved)
  function showCodeLink() {
    const link = document.getElementById("bw-code-link");
    if (link) link.style.display = "inline-block";
  }

  function toggleCodeBox() {
    const box = document.getElementById("bw-code-box");
    const open = box.style.display !== "none";
    box.style.display = open ? "none" : "flex";
    if (!open) { const i = document.getElementById("bw-code-input"); i.value = getAccessCode(); i.focus(); }
  }

  function saveAccessCode() {
    const value = document.getElementById("bw-code-input").value.trim();
    const was = getAccessCode();
    setAccessCode(value);
    document.getElementById("bw-code-box").style.display = "none";
    showStaffState();

    // The guide is held per make once it has been fetched, and what came back depended on
    // whether a code was sent. Changing the code makes that copy wrong, so it goes.
    if (value !== was) {
      // What came back last time depended on the code, so the makes, the guides and the
      // rows are all out of date together. Fetch them again rather than patch them.
      rowsByMake = {};
      loadVehicleData().catch(() => {});
      if (STAFF_PAGE) {
        showWidgetMessage(value
          ? "Code saved on this device. Search the vehicle again and the team notes will show."
          : "Code removed. Team notes won't show until a code is saved again.", "info");
        return;
      }
    }
    showWidgetMessage(value ? "Code saved on this device." : "Code removed.", "info");
  }

  /* ---------- helpers ---------- */
  const normKey = s => String(s || "").toLowerCase().replace(/[^a-z0-9]/g, "");
  // Same rule Shopify uses to turn a tag into a URL: "Q85 EFB" -> "q85-efb"
  const shopifyHandle = s => String(s || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
  // "CX-7 Petrol 2.3i" -> ["cx","7","petrol","2.3i"] ; "Mazda 3" -> ["mazda","3"]
  const words = s => String(s || "").toLowerCase().match(/[a-z]+|\d+(?:\.\d+)?[a-z]*/g) || [];
  const escHtml = s => String(s || "").replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  // For a value going inside a single-quoted onclick="...('here')"
  const escAttr = s => escHtml(s).replace(/&#39;/g, "\\&#39;");

  // "2005-2012", "08/2008-on", "1997-07/2002", "2016-on" -> month numbers
  function parseYearRange(str) {
    const s = String(str || "").trim().toLowerCase();
    const m = s.match(/^(?:(\d{1,2})\/)?(\d{4})\s*-\s*(?:(on)|(?:(\d{1,2})\/)?(\d{4}))$/);
    if (!m) {
      const y = s.match(/^(\d{4})$/);
      return y ? { from: +y[1] * 12, to: +y[1] * 12 + 11 } : null;
    }
    const from = (+m[2]) * 12 + (m[1] ? +m[1] - 1 : 0);
    const to = m[3] ? 9999 * 12 : (+m[5]) * 12 + (m[4] ? +m[4] - 1 : 11);
    return { from, to };
  }

  // strict: use the build month when we have it. loose: anywhere in the year.
  // Within `slack` years of a row's range – used only when nothing matched outright
  function yearNear(rangeStr, year, slack) {
    const r = parseYearRange(rangeStr);
    if (!r || !year) return false;
    const y = +year * 12;
    return y + 11 >= r.from - slack * 12 && y <= r.to + slack * 12;
  }

  function yearMatches(rangeStr, year, compliance, strict) {
    if (!year) return true;
    const r = parseYearRange(rangeStr);
    if (!r) return false;
    const c = String(compliance || "").match(/^(\d{4})-(\d{1,2})/);
    if (strict && c) {
      const t = (+c[1]) * 12 + (+c[2] - 1);
      return t >= r.from && t <= r.to;
    }
    const y = +year;
    return y * 12 + 11 >= r.from && y * 12 <= r.to;
  }

  // Newest ranges first
  function sortYears(years) {
    return years.sort((a, b) => ((parseYearRange(b) || { from: 0 }).from) - ((parseYearRange(a) || { from: 0 }).from));
  }

  /* ---------- plate styling ---------- */
  function applyPlateTheme(key) {
    const plate = document.getElementById("bw-plate");
    if (!plate) return;
    // NHVR is a register rather than a state, so it gets the heavy plate and its own badge
    const heavy = key === "NHVR" || key === "HEAVY";
    plate.classList.toggle("bw-plate-heavy", heavy);
    if (heavy) key = "HEAVY";
    const theme = PLATE_THEMES[key] || PLATE_THEMES.VIC;
    plate.style.setProperty("--plate-accent", theme.accent || theme.text);
    plate.style.setProperty("--plate-text", theme.text);
    plate.style.setProperty("--plate-bg", theme.bg || "#ffffff");
    // Plates with a white background get a filled state block; coloured plates (NSW) keep the plate colour
    const plainPlate = (theme.bg || "#ffffff").toLowerCase() === "#ffffff";
    plate.style.setProperty("--plate-badge-bg", plainPlate ? (theme.accent || theme.text) : "transparent");
    plate.style.setProperty("--plate-badge-text", plainPlate ? "#ffffff" : theme.text);
    const regoInput = document.getElementById("bw-rego-input");
    if (regoInput) regoInput.placeholder = theme.placeholder || "E.G. ABC123";
    document.getElementById("bw-plate-state-abbr").textContent = heavy ? "NHVR" : key;
    document.getElementById("bw-plate-caption").textContent = theme.name;
  }

  // A heavy vehicle is registered either nationally or with a state, and the two are
  // separate registers. NHVR is only offered on Truck & bus, and only there is it the
  // sensible default - a car is never on it.
  function setRegoStates(heavyAllowed) {
    const sel = document.getElementById("bw-rego-state");
    if (!sel) return "VIC";
    let nhvr = sel.querySelector('option[value="NHVR"]');
    if (!nhvr) {
      nhvr = document.createElement("option");
      nhvr.value = "NHVR";
      nhvr.textContent = "NHVR";
      sel.insertBefore(nhvr, sel.firstChild);
    }
    nhvr.hidden = !heavyAllowed;
    nhvr.disabled = !heavyAllowed;
    if (heavyAllowed) {
      if (!lastCarState || lastCarState === "NHVR") lastCarState = "VIC";
      sel.value = "NHVR";
    } else if (sel.value === "NHVR") {
      sel.value = lastCarState || "VIC";
    }
    return sel.value;
  }

  let lastCarState = "";

  function toggleRegoType(type) {
    pickedGuide = (type === 'truck' || type === 'commercial') ? 'truck' : 'car';
    const plate = document.getElementById('bw-plate');
    if (!plate) return;
    const isHeavy = (type === 'commercial' || type === 'truck');
    const sel = document.getElementById('bw-rego-state');
    if (sel && sel.value && sel.value !== 'NHVR') lastCarState = sel.value;
    applyPlateTheme(setRegoStates(isHeavy));
  }

  // Which report the plate goes to. A heavy plate is a different query at a different
  // price, so the button the customer picked decides it rather than the plate itself.
  function regoCategory() {
    const picked = document.querySelector('input[name="rtype"]:checked');
    const v = picked ? picked.value : "car";
    return (v === "truck" || v === "commercial") ? "truck" : "car";
  }

  /* ---------- live YMM data ---------- */
  async function loadVehicleData() {
    try {
      const res = await fetch(withCode(YMM_DATA_URL), { cache: "no-store" });
      const data = await res.json();
      if (!data.success && data.error === "rate_limited") {
        showCodeLink();
        showWidgetMessage(`You've reached today's limit for vehicle searches from this connection. Please try again ${escHtml(data.retryAfter || "tomorrow")}. Trade and staff can enter their code underneath.`, "warning");
        return;
      }
      if (!data.success) throw new Error(data.error || "YMM data unavailable");
      // The master switch in Volt. A fault in the finder itself means no search can be trusted,
      // so the whole thing is replaced by a way to reach a person rather than left half-working.
      if (data.status && data.status.finderAvailable === false) {
        setFinderOff(data.status.finderMessage);
        return;
      }
      publicClasses = (data.status && data.status.publicClasses) || publicClasses;
      makeGuides = data.makeGuides || {};
      staffGuides = data.staff === true;
      makesList = data.makes || [];
      // "Treat this make as…" rules set in the portal. They sit on top of the built-in
      // list, so the team can fix a mismatch without this file being changed.
      portalAliases = {};
      Object.entries(data.aliases || {}).forEach(([k, v]) => {
        if (Array.isArray(v) && v.length) portalAliases[String(k).toUpperCase()] = v;
      });
      // The same for model names. These are held against a make, so an entry only ever
      // applies once the make has been resolved to one of ours.
      portalModelAliases = {};
      Object.entries(data.modelAliases || {}).forEach(([make, rules]) => {
        if (!rules || typeof rules !== "object") return;
        const into = {};
        Object.entries(rules).forEach(([k, v]) => {
          if (Array.isArray(v) && v.length) into[String(k).toUpperCase()] = v;
        });
        if (Object.keys(into).length) portalModelAliases[String(make).toUpperCase()] = into;
      });
      dataReady = true;
      paintGuideButtons();
      populateMakes();
      if (data.status && data.status.regoAvailable === false) setRegoOff(data.status.message);
    } catch (err) {
      console.error("Vehicle data loading error:", err);
      showWidgetMessage("Vehicle list couldn't be loaded. Please refresh the page or try again shortly.", "error");
    }
  }

  // The rego service calls plenty of utes and vans trucks. We only tell someone their
  // vehicle is outside the guide when the truck guide genuinely isn't open to them - staff
  // with a code, or everyone once Volt makes it public.
  let publicClasses = ["car"], staffGuides = false, makeGuides = {}, pickedGuide = "car";
  const truckGuideOn = () => staffGuides || publicClasses.indexOf("truck") > -1;

  // Vehicles are fetched one make at a time, so the full list is never sent in one go
  async function ensureMakeRows(make) {
    if (rowsByMake[make]) return rowsByMake[make];
    const res = await fetch(withCode(`${YMM_DATA_URL}?make=${encodeURIComponent(make)}`), { cache: "no-store" });
    const data = await res.json();
    if (!data.success && data.error === "rate_limited") { showCodeLink(); throw new Error("rate_limited"); }
    if (!data.success) throw new Error(data.error || "YMM data unavailable");
    rowsByMake[make] = data.rows || [];
    return rowsByMake[make];
  }

  function rowsFor(make) { return rowsByMake[make] || []; }

  // The Make, Model and Year lists only ever offer the guide that is selected. Staff are
  // served all three guides in one go, so without this a make that sells both - Hyundai,
  // Toyota, Isuzu - puts its excavators in the Model list under Car.
  function guideRowsFor(make) {
    const all = rowsFor(make);
    if (pickedGuide === "all") return all;
    const mine = all.filter(r => String(r.guide || "car").toLowerCase() === pickedGuide);
    return mine.length || all.some(r => r.guide) ? mine : all;
  }

  // What the customer sees and picks: the model with its grade on the end. The two are kept
  // apart in the guide so matching, filtering and merging stay clean, and are only joined
  // here, where a person reads them. Everything in the Vehicle tab keys off this name, so a
  // GLA180 and a GLA250 are two entries in the Model list rather than one ambiguous "GLA".
  // Supplier lists bundle variants into one line - "2.0i / 2.4i VTi , 2WD & AWD, all models".
  // The spacing and the "all models" are theirs, not ours, and only the customer sees them,
  // so they are tidied here rather than by hand on the way in. Nothing about matching reads
  // this - it is the label and nothing else.
  function tidyLabel(text) {
    return String(text == null ? "" : text)
      .replace(/\s*,?\s*\ball\s+models\b/gi, "")
      .replace(/\s+([,;])/g, "$1")
      .replace(/\s*\/\s*/g, " / ")
      .replace(/\s{2,}/g, " ")
      .replace(/[\s,]+$/, "")
      .trim();
  }

  function modelName(row) {
    const model = String((row && row.model) || "").trim();
    const grade = String((row && row.grade) || "").trim();
    if (!grade) return tidyLabel(model);
    const m = normKey(model), g = normKey(grade);
    if (!m) return tidyLabel(grade);
    if (m.indexOf(g) > -1) return tidyLabel(model);      // "GLA180 Stop Start" already says GLA180
    if (g.indexOf(m) === 0) return tidyLabel(grade);     // model "GLA" + grade "GLA250 4-MATIC" -> "GLA250 4-MATIC"
    return tidyLabel(model + " " + grade);               // "Hilux" + "SR5" -> "Hilux SR5"
  }

  // Same name, different battery: the series is the only thing telling the two apart, so it
  // goes on the end. Used only where that actually happens, which keeps "X156" out of every
  // other name in the list.
  function modelNameWithSeries(row) {
    const series = String((row && row.series) || "").trim();
    return series ? modelName(row) + " (" + series + ")" : modelName(row);
  }

  // A commercial row with no year covers every year. The guide decides: on a car a blank
  // year is a mistake, and the wrong generation is the wrong battery.
  function openEndedRow(r) {
    return !String((r && r.year) || "").trim()
        && String((r && r.guide) || "car").toLowerCase() !== "car";
  }

  // A name from either of the two above, back to the rows it came from
  function rowIsModel(r, label) {
    if (modelName(r) === label || modelNameWithSeries(r) === label) return true;
    // A name saved before the label was tidied, e.g. in someone's garage
    const raw = String((r && r.model) || "").trim();
    return raw === label || (raw && raw + " (" + String((r && r.series) || "").trim() + ")" === label);
  }

  // Rego search switched off in the portal (planned or unplanned outage)
  function setFinderOff(message) {
    finderOff = true;
    const text = String(message || "").trim() ||
      "Our battery finder is temporarily unavailable while we fix a fault. Give us a ring and we'll tell you exactly what fits your vehicle and have it ready for you.";
    const panels = document.querySelectorAll(".battery-widget-container");
    if (!panels.length) return;
    panels.forEach(el => {
      el.innerHTML = `<div class="bwr-empty" role="status">
        <p class="bwr-empty-title">The battery finder is unavailable right now</p>
        <p class="bwr-empty-text">${escHtml(text)}</p>
        <div class="bwr-empty-acts">
          <a class="bw-btn" href="${escHtml(PHONE_LINK)}">Call ${escHtml(PHONE_NUMBER)}</a>
          <a class="bw-btn bw-btn-ghost" href="${escHtml(CONTACT_URL)}">Contact us <span class="bwr-arrow" aria-hidden="true">&rarr;</span></a>
        </div>
      </div>`;
    });
  }

  function setRegoOff(message) {
    regoOff = true;
    const btn = document.getElementById("bw-rego-btn");
    const input = document.getElementById("bw-rego-input");
    if (btn) { btn.disabled = true; btn.innerText = "Unavailable"; }
    if (input) { input.disabled = true; input.placeholder = "UNAVAILABLE"; }
    const tab = document.querySelectorAll(".bw-tab-link")[0];
    if (tab && tab.classList.contains("active")) showWidgetMessage(escHtml(message || "Registration search is temporarily unavailable. Please search by Make, Model and Year."), "warning");
    regoOffMessage = message || "";
  }

  function getSelectedCsvVehicleType() { return VEHICLE_TYPE; }
  // Car / Truck and bus / Plant narrow the Make list to that guide. A make that sells both -
  // Toyota, Isuzu - shows under both.
  function onVehicleTypeChange(guide) {
    pickedGuide = String(guide || "car").toLowerCase();
    populateMakes();
  }

  // The Truck and bus and Plant buttons only exist for someone who can actually search them:
  // staff with a code, or everyone once Volt makes that guide public. Showing a button that
  // returns an empty list is worse than not showing it.
  function guideOpen(guide) {
    if (guide === "car") return true;
    return staffGuides || publicClasses.indexOf(guide) > -1;
  }

  // The label sits as a bare text node after the icon, so it can be retitled without
  // rebuilding the card and losing the radio inside it.
  function guideCardText(card) {
    const span = card.querySelector("span");
    if (!span) return null;
    for (let i = span.childNodes.length - 1; i >= 0; i--) {
      const n = span.childNodes[i];
      if (n.nodeType === 3 && n.nodeValue.trim()) return n;
    }
    return null;
  }

  function paintGuideButtons() {
    let hidTheOneInUse = false;
    // All four are always on show, so the row never reflows and nobody has to wonder whether
    // we do trucks. A guide that isn't open yet reads as coming soon and can't be clicked,
    // which is the same promise the Motorcycle card has always made.
    document.querySelectorAll(".bw-vcard[data-guide]").forEach(card => {
      const guide = card.getAttribute("data-guide");
      const on = guideOpen(guide);
      const node = guideCardText(card);
      if (node && !card.getAttribute("data-label")) card.setAttribute("data-label", node.nodeValue.trim());
      const label = card.getAttribute("data-label") || "";
      card.style.display = "";
      card.classList.toggle("bw-vcard-soon", !on);
      if (on) card.removeAttribute("aria-disabled"); else card.setAttribute("aria-disabled", "true");
      if (node) node.nodeValue = " " + label + (on ? "" : " \u00b7 Coming soon") + " ";
      const radio = card.querySelector("input[type=radio]");
      if (radio) {
        radio.disabled = !on;
        if (!on && radio.checked) { radio.checked = false; hidTheOneInUse = true; }
      }
    });
    if (hidTheOneInUse) {
      document.querySelectorAll('input[type=radio][value="car"]').forEach(r => { r.checked = true; });
      pickedGuide = "car";
    }
    document.querySelectorAll(".bw-soon-text").forEach(el => { el.textContent = "Motorcycle \u00b7 Coming soon"; });
    document.querySelectorAll(".bw-vehicle-cards").forEach(row => {
      row.setAttribute("data-cols", String(row.querySelectorAll(".bw-vcard").length || 4));
    });
  }

  // Plant is only reachable through Make / Model / Year, so coming back to the plate should
  // not leave Plant showing as the thing being searched.
  function resetRegoType() {
    const picked = document.querySelector('input[name="rtype"]:checked');
    const v = picked ? picked.value : "";
    if (v && v !== "plant") return;
    const car = document.querySelector('input[name="rtype"][value="car"]');
    if (car) car.checked = true;
    toggleRegoType("car");
  }

  // No fallback to the whole list. A guide with nothing in it yet says so, rather than
  // quietly handing someone looking for a tractor the car makes.
  function makesInGuide() {
    if (!makesList.length) return [];
    if (pickedGuide === "all" || !Object.keys(makeGuides).length) return [...makesList];
    return makesList.filter(m => (makeGuides[m] || ["car"]).indexOf(pickedGuide) > -1);
  }

  const GUIDE_NAME = { car: "cars", truck: "trucks and buses", plant: "plant", motorcycle: "motorcycles" };

  // Plant has no plates, so the only way in is Make / Model / Year.
  // Put the rego tab on a named guide without anyone clicking. Used by a replay, which has
  // to run under the guide the plate was originally searched with or it matches against
  // the wrong half of the guide.
  function setRegoGuide(guide) {
    const want = (guide === "truck" && guideOpen("truck")) ? "truck" : "car";
    const radio = document.querySelector('input[name="rtype"][value="' + want + '"]');
    if (radio) radio.checked = true;
    toggleRegoType(want);
  }

  function chooseRegoType(type) {
    if (type === "plant") {
      const radio = document.querySelector('input[name="vtype"][value="plant"]');
      if (radio) radio.checked = true;
      onVehicleTypeChange("plant");
      const tab = document.querySelector('.bw-tab-link[onclick*="tab-vehicle"]')
               || document.querySelector('[onclick*="tab-vehicle"]');
      if (tab) tab.click();
      return;
    }
    toggleRegoType(type);
  }

  /* ---------- dropdown controls ---------- */
  function handleDropdownKeyDown(e, type) {
    const items = document.getElementById(`dd-list-${type}`).querySelectorAll(".bw-dd-item");
    if (!items.length) return;
    if (e.key === "ArrowDown") {
      e.preventDefault();
      highlightedIndices[type] = Math.min(highlightedIndices[type] + 1, items.length - 1);
      updateItemHighlight(type, items);
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      highlightedIndices[type] = Math.max(highlightedIndices[type] - 1, 0);
      updateItemHighlight(type, items);
    } else if (e.key === "Enter") {
      e.preventDefault();
      let idx = highlightedIndices[type];
      if (idx < 0 || idx >= items.length) idx = 0;
      if (items[idx]) items[idx].click();
    } else if (e.key === "Home") {
      e.preventDefault();
      highlightedIndices[type] = 0;
      updateItemHighlight(type, items);
    } else if (e.key === "End") {
      e.preventDefault();
      highlightedIndices[type] = items.length - 1;
      updateItemHighlight(type, items);
    } else if (e.key === "Escape") {
      e.preventDefault();
      closeAllDropdowns();
      const btn = document.getElementById(`dd-btn-${type}`);
      if (btn) btn.focus();
    } else if (e.key === "Tab") {
      closeAllDropdowns();
    }
  }

  function updateItemHighlight(type, items) {
    const search = document.getElementById(`dd-search-${type}`);
    items.forEach((item, idx) => {
      if (idx === highlightedIndices[type]) {
        item.classList.add("highlighted");
        item.scrollIntoView({ block: "nearest" });
        if (search && item.id) search.setAttribute("aria-activedescendant", item.id);
      } else item.classList.remove("highlighted");
    });
    if (search && highlightedIndices[type] < 0) search.removeAttribute("aria-activedescendant");
  }

  // Arrow down on the closed button opens the list and lands on the first option, which is
  // what anyone working down the form with the keyboard expects
  function openDropdownOnArrow(e, type) {
    if (e.key !== "ArrowDown" && e.key !== "ArrowUp") return;
    e.preventDefault();
    const wrapper = document.getElementById(`dd-wrapper-${type}`);
    if (!wrapper || wrapper.classList.contains("open")) return;
    toggleDropdown(type);
  }

  function toggleDropdown(type) {
    const wrapper = document.getElementById(`dd-wrapper-${type}`);
    const isOpen = wrapper.classList.contains("open");
    closeAllDropdowns();
    if (!isOpen) {
      wrapper.classList.add("open");
      const btn = document.getElementById(`dd-btn-${type}`);
      if (btn) btn.setAttribute("aria-expanded", "true");
      const searchInput = document.getElementById(`dd-search-${type}`);
      searchInput.value = "";
      searchInput.setAttribute("aria-expanded", "true");
      filterDropdownOptions(type, "");
      setTimeout(() => searchInput.focus(), 50);
    }
  }

  function closeAllDropdowns() {
    document.querySelectorAll(".bw-dd-wrapper").forEach(w => {
      w.classList.remove("open");
      const btn = w.querySelector(".bw-dd-trigger");
      const search = w.querySelector(".bw-dd-search");
      if (btn) btn.setAttribute("aria-expanded", "false");
      if (search) { search.setAttribute("aria-expanded", "false"); search.removeAttribute("aria-activedescendant"); }
    });
  }

  function renderCustomList(type, items) {
    const listEl = document.getElementById(`dd-list-${type}`);
    listEl.innerHTML = "";
    highlightedIndices[type] = -1;
    if (!items.length) { listEl.innerHTML = '<li class="bw-dd-empty">No results found</li>'; return; }
    items.forEach((val, i) => {
      const li = document.createElement("li");
      li.className = `bw-dd-item ${selectedValues[type] === val ? 'selected' : ''}`;
      li.id = `dd-opt-${type}-${i}`;
      li.setAttribute("role", "option");
      li.setAttribute("aria-selected", selectedValues[type] === val ? "true" : "false");
      li.textContent = val;
      li.onclick = (e) => {
        e.stopPropagation();
        // Picking a Make by hand starts a fresh, free search; picking a model or year
        // after a rego result still belongs to that rego search.
        if (type === "make") {
          regoKicker = ""; searchKind = "manual"; searchRef = null; voteRef = null;
          pendingNotes = []; pendingLabel = ""; pendingModel = ""; pendingFitNote = "";
        }
        selectOption(type, val, true);
      };
      listEl.appendChild(li);
    });
  }

  function filterDropdownOptions(type, query) {
    const q = query.toLowerCase().trim();
    renderCustomList(type, optionsData[type].filter(item => String(item).toLowerCase().includes(q)));
  }

  // byUser is true only when someone clicked or pressed Enter on a list item. A rego result
  // or a saved vehicle fills these in by code, and must not pop a dropdown open over the
  // batteries it just found.
  function selectOption(type, value, byUser) {
    selectedValues[type] = value;
    document.getElementById(`dd-label-${type}`).textContent = value;
    closeAllDropdowns();
    showClearButton();
    if (type === 'make') return onMakeSelect(value, byUser);
    if (type === 'model') onModelSelect(value, byUser);
    else if (type === 'year') onYearSelect(value);
  }

  // Carry on to the next thing the customer has to answer, so picking a make doesn't mean
  // reaching for the mouse again. Nothing opens if there is only one answer - that one is
  // chosen for them instead.
  function stepTo(type) {
    const btn = document.getElementById(`dd-btn-${type}`);
    if (!btn || btn.disabled) return;
    const wrapper = document.getElementById(`dd-wrapper-${type}`);
    if (wrapper && wrapper.classList.contains("open")) return;
    toggleDropdown(type);
  }

  /* ---------- cascading dropdowns ---------- */
  function populateMakes() {
    selectedValues = { make: "", model: "", year: "" };
    showClearButton();
    document.getElementById("dd-label-make").textContent = "Select Make...";
    document.getElementById("dd-label-model").textContent = "Select Model...";
    document.getElementById("dd-label-year").textContent = "Select Year...";
    document.getElementById("dd-btn-model").disabled = true;
    document.getElementById("dd-btn-year").disabled = true;
    if (!dataReady) return;
    optionsData.make = makesInGuide();
    renderCustomList("make", optionsData.make);
    const makeBtn = document.getElementById("dd-btn-make");
    const label = document.getElementById("dd-label-make");
    const empty = !optionsData.make.length;
    makeBtn.disabled = empty;
    if (empty && label) label.textContent = "No " + (GUIDE_NAME[pickedGuide] || pickedGuide) + " in the guide yet";
  }

  async function onMakeSelect(make, byUser) {
    hideWidgetMessage();
    selectedValues.model = ""; selectedValues.year = "";
    document.getElementById("dd-label-model").textContent = "Select Model...";
    document.getElementById("dd-label-year").textContent = "Select Year...";
    document.getElementById("dd-btn-year").disabled = true;
    document.getElementById("dd-btn-model").disabled = true;
    try {
      await ensureMakeRows(make);
      optionsData.model = [...new Set(guideRowsFor(make).map(modelName))].sort();
      renderCustomList("model", optionsData.model);
      document.getElementById("dd-btn-model").disabled = false;
      if (!byUser) return;
      if (optionsData.model.length === 1) selectOption("model", optionsData.model[0], true);
      else stepTo("model");
    } catch (err) {
      console.error("Model list error:", err);
      showWidgetMessage("Couldn't load the models for that make. Please try again shortly.", "error");
    }
  }

  function onModelSelect(model, byUser) {
    hideWidgetMessage();
    selectedValues.year = "";
    document.getElementById("dd-label-year").textContent = "Select Year...";
    const rows = rowsFor(selectedValues.make).filter(r => rowIsModel(r, model));
    optionsData.year = sortYears([...new Set(rows.map(r => r.year).filter(Boolean))]);
    renderCustomList("year", optionsData.year);
    // Nothing to pick between. Opening an empty list and asking anyway is a dead end, so
    // the box says so and the search goes ahead on the model alone.
    if (!optionsData.year.length) {
      document.getElementById("dd-btn-year").disabled = true;
      document.getElementById("dd-label-year").textContent = "Any year";
      submitYMMSearchInterim();
      return;
    }
    document.getElementById("dd-btn-year").disabled = false;
    if (optionsData.year.length === 1) { selectOption('year', optionsData.year[0], byUser); return; }
    if (byUser) stepTo("year");
  }

  // Customer notes/warnings for the selected vehicle
  // Make, Model and Year are all filled (picked or pre-filled) -> show the batteries straight away
  function onYearSelect(year) {
    if (selectedValues.make && selectedValues.model && year) submitYMMSearchInterim();
  }

  /* ---------- submit & redirect ---------- */
  function submitYMMSearchInterim() {
    const { make, model, year } = selectedValues;
    if (!make || !model) { showWidgetMessage("Please select a Make and Model.", "warning"); return; }
    if (!year && optionsData.year.length > 1) { showWidgetMessage("Please select the Year of your vehicle.", "warning"); return; }

    if (redirectMode() && sendToResultsPage({ make: make, model: model, year: year || "" })) return;

    const rows = rowsFor(make).filter(r => rowIsModel(r, model) && (!year || r.year === year || openEndedRow(r)));
    goToResults(rows, `${make} ${model}${year ? " (" + year + ")" : ""}`);
  }

  // Show the results on this page (and put them in the address so the link can be shared / Back works)
  // A quiet line under the vehicle name, only when several variants share one battery
  // Plenty of trucks, buses and machines carry more than one battery, and the prices on the
  // cards are each. Someone who buys one and finds the tray half empty has had a wasted trip,
  // so this says it before they get to the cart rather than after.
  function showQtyNote(n) {
    const many = Number(n) > 1 ? Math.round(Number(n)) : 0;
    let el = document.getElementById("bwr-qtynote");
    if (!el) {
      if (!many) return;
      const grid = document.getElementById("bwr-grid");
      if (!grid || !grid.parentNode) return;
      el = document.createElement("div");
      el.id = "bwr-qtynote";
      el.className = "bwr-qtynote";
      el.setAttribute("role", "status");
      grid.parentNode.insertBefore(el, grid);
    }
    if (!many) { el.style.display = "none"; el.innerHTML = ""; return; }
    const word = many === 2 ? "two" : many === 3 ? "three" : many === 4 ? "four" : String(many);
    el.innerHTML = `<strong>Our guide says this vehicle carries ${escHtml(word)} batteries.</strong>
      The price on each card is for one battery, so choose ${escHtml(word)} if you are replacing the lot.
      Not sure? <a href="${escHtml(PHONE_LINK)}">Call ${escHtml(PHONE_NUMBER)}</a> or
      <a href="${escHtml(CONTACT_URL)}">contact us</a> and we will check it for you.`;
    el.style.display = "block";
  }

  function showFitNote(text) {
    let el = document.getElementById("bwr-fitnote");
    if (!el) {
      const title = document.getElementById("bwr-vehicle");
      if (!title || !title.parentNode) return;
      el = document.createElement("div");
      el.id = "bwr-fitnote";
      el.className = "bwr-fitnote";
      title.parentNode.insertBefore(el, title.nextSibling);
    }
    el.textContent = text || "";
    el.style.display = text ? "block" : "none";
  }

  /**
   * The matched vehicle as separate fields rather than one run-on line, so the customer can
   * check each part against their own car. A field is only shown when every row agrees on it
   * and the name above doesn't already say it.
   */
  function vehicleSpec(rows) {
    const list = rows || [];
    const first = list[0] || {};
    const agreed = key => {
      const vals = [...new Set(list.map(r => String((r && r[key]) || "").trim()).filter(Boolean))];
      return vals.length === 1 ? vals[0] : "";
    };
    // Where several variants were folded into one answer, the Model row says what the
    // register called the car. Naming a variant we never chose between tells a 4.2 owner
    // they have the 2.8, and they are quite right to say that isn't their model.
    const model = pendingModel || selectedValues.model || (first.model ? modelName(first) : "");
    const said = normKey(model);
    const notSaid = v => v && said.indexOf(normKey(v)) < 0 ? v : "";
    return [
      { label: "Make", value: selectedValues.make || first.make || "" },
      { label: "Model", value: model },
      { label: "Series", value: notSaid(agreed("series")) },
      { label: "Grade", value: notSaid(agreed("grade")) },
      { label: "Year", value: selectedValues.year || agreed("year") },
    ];
  }

  function goToResults(rows, vehicleLabel) {
    // When several variants were folded together, the heading is the customer's own car
    if (pendingLabel) { vehicleLabel = pendingLabel; pendingLabel = ""; }
    pendingFacts = vehicleSpec(rows);
    pendingModel = "";
    const codes = [...new Set(rows.flatMap(r => String(r.fitmentCode || "").split(",").map(c => c.trim()).filter(Boolean)))];
    // The most any folded-together variant carries, so a two-battery bus is never told one.
    pendingQty = Math.max(1, ...rows.map(r => Number(r.qty) || 1));
    // Warnings from every variant we folded together, so collapsing options never loses one
    const noteRows = rows.map(r => r.notes).concat(pendingNotes);
    pendingNotes = [];
    pendingTeamNotes = STAFF_PAGE
      ? [...new Set(rows.flatMap(r => String(r.teamNotes || "").split(";").map(x => x.trim()).filter(Boolean)))]
      : [];
    const notes = [...new Set(noteRows.flatMap(n => String(n || "").split(";").map(x => x.trim()).filter(Boolean)))];
    if (!codes.length) {
      showWidgetMessage("We don't have a battery match for this vehicle yet. Please contact us and we'll help you find the right one.", "info");
      return;
    }
    const url = new URL(window.location.href);
    url.searchParams.set("fc", codes.join(","));
    url.searchParams.set("v", vehicleLabel);
    if (notes.length) url.searchParams.set("n", notes.join("; ")); else url.searchParams.delete("n");
    if (pendingQty > 1) url.searchParams.set("q", String(pendingQty)); else url.searchParams.delete("q");
    history.pushState({ bwResults: true }, "", url);

    // Remember the vehicle, not the battery – the codes are looked up again next time
    const { make, model, year } = selectedValues;
    if (make && model) {
      // A plate only belongs to this car if the rego search was a few minutes ago at most
      const fromRego = lastPlate && (Date.now() - lastPlate.at) < 10 * 60 * 1000 ? lastPlate : null;
      const existing = readGarage().find(c => normKey(c.make) === normKey(make) && normKey(c.model) === normKey(model) && (c.year || "") === (year || ""));
      saveToGarage({
        make, model, year: year || "",                       // the guide's year range
        built: (fromRego && fromRego.built) || (existing && existing.built) || "",   // the car's actual year
        plate: (fromRego && fromRego.rego) || (existing && existing.plate) || "",
        state: (fromRego && fromRego.state) || (existing && existing.state) || "",
      });
    }
    lastPlate = null;
    reportEvent("results", codes.join(","));

    renderResults(codes, vehicleLabel, notes);
  }

  function showResultsFromUrl() {
    const p = new URLSearchParams(window.location.search);
    const fc = (p.get("fc") || "").split(",").map(c => c.trim()).filter(Boolean);
    if (!fc.length) { document.getElementById("bwr-panel").style.display = "none"; return; }
    pendingQty = Math.max(1, Number(p.get("q")) || 1);
    renderResults(fc, p.get("v") || "", (p.get("n") || "").split(";").map(n => n.trim()).filter(Boolean), false);
  }
  window.addEventListener("popstate", showResultsFromUrl);

  /* ---------- My garage (saved in this browser only) ---------- */
  // Vehicles the customer has looked up before, kept in localStorage so they can come
  // straight back to their car without paying for another rego lookup. The Make/Model/Year
  // is what's saved – the fitment codes are read fresh from the guide every time, so a
  // change in the portal reaches a saved car automatically.
  const GARAGE_KEY = "be_garage_v1";
  const GARAGE_MAX = 6;
  let lastPlate = null;             // { rego, state } while a rego result is being turned into results

  function readGarage() {
    try {
      const list = JSON.parse(localStorage.getItem(GARAGE_KEY) || "[]");
      return Array.isArray(list) ? list.filter(c => c && c.make && c.model) : [];
    } catch (e) { return []; }      // private browsing, or storage full/blocked
  }

  function writeGarage(list) {
    try { localStorage.setItem(GARAGE_KEY, JSON.stringify(list.slice(0, GARAGE_MAX))); } catch (e) { /* nothing we can do */ }
    renderGarage();
  }

  const garageKeyOf = c => normKey(c.make) + "|" + normKey(c.model) + "|" + normKey(c.year || "");
  // "2025 Great Wall Tank 300 Petrol" – the car's own year, never the guide's year range
  const garageName = c => [c.built, c.make, c.model].filter(Boolean).join(" ");

  function saveToGarage(car) {
    const list = readGarage().filter(c => garageKeyOf(c) !== garageKeyOf(car));
    // Keep the plate we already had for this car if this visit didn't come from a rego search
    writeGarage([{ ...car, at: Date.now() }, ...list]);
  }

  function removeFromGarage(key) {
    writeGarage(readGarage().filter(c => garageKeyOf(c) !== key));
    hideWidgetMessage();
  }

  function renderGarage() {
    let wrap = document.getElementById("bw-garage");
    const banner = document.getElementById("bw-status-banner");
    if (!wrap) {
      if (!banner || !banner.parentNode) return;
      wrap = document.createElement("div");
      wrap.id = "bw-garage";
      wrap.className = "bw-garage";
      banner.parentNode.insertBefore(wrap, banner.nextSibling);
    }
    const list = readGarage();
    if (!list.length) { wrap.style.display = "none"; wrap.innerHTML = ""; return; }

    wrap.style.display = "block";
    wrap.innerHTML = `
      <div class="bw-garage-head">
        <span class="bw-garage-title">My garage</span>
        <button type="button" class="bw-garage-clear" onclick="bwGarageClear()">Clear all</button>
      </div>
      <div class="bw-garage-row">
        ${list.map(c => {
          const key = garageKeyOf(c);
          return `<div class="bw-gcard">
            <button type="button" class="bw-gcard-main" onclick="bwGarageUse('${escAttr(key)}')"
                    title="Show batteries for this vehicle">
              <span class="bw-gcard-name">${escHtml(garageName(c))}</span>
              ${c.plate
                ? `<span class="bw-gcard-plate">${escHtml(c.plate)}${c.state ? " · " + escHtml(c.state) : ""}</span>`
                : `<span class="bw-gcard-sub">${escHtml(c.year || "Saved vehicle")}</span>`}
            </button>
            <button type="button" class="bw-gcard-x" aria-label="Remove this vehicle"
                    onclick="bwGarageRemove('${escAttr(key)}')">&times;</button>
          </div>`;
        }).join("")}
      </div>
      <div class="bw-garage-note">Saved on this device only. Remove a car and search again if anything looks wrong.</div>`;
  }

  // Bring a saved car back. The guide is re-read, so the codes are always current.
  async function useGarageCar(key) {
    const car = readGarage().find(c => garageKeyOf(c) === key);
    if (!car) return;
    hideWidgetMessage();
    if (!dataReady) { showWidgetMessage("Still loading vehicle data – please try again in a moment.", "info"); return; }

    // The make may have been renamed or retired in the guide since this was saved
    const make = makesList.find(m => normKey(m) === normKey(car.make));
    if (!make) return garageStale(car, key);
    await ensureMakeRows(make);
    const saved = normKey(car.model);
    const rows = rowsFor(make).filter(r =>
      (normKey(modelName(r)) === saved || normKey(modelNameWithSeries(r)) === saved || normKey(r.model) === saved)
      && (!car.year || r.year === car.year || openEndedRow(r)));
    if (!rows.length) return garageStale(car, key);

    searchKind = "garage";                 // a repeat visit, and it cost us nothing
    searchRef = null;
    voteRef = null;                        // they told us this was their car when they saved it
    regoKicker = car.plate
      ? `Saved vehicle ${car.plate}${car.state ? " (" + car.state + ")" : ""} · ${garageName(car)} · Batteries to suit`
      : `Saved vehicle · ${garageName(car)} · Batteries to suit`;
    await prefillVehicleTab(make, [modelName(rows[0])], modelName(rows[0]), car.year || rows[0].year);
  }

  // The guide no longer has this vehicle – don't quietly show the wrong battery
  function garageStale(car, key) {
    const label = escHtml(garageName(car));
    showWidgetMessage(
      `Our battery guide has been updated for your <strong>${label}</strong>, so we've stopped using the saved details. ` +
      `<button type="button" class="bw-inline-link" onclick="bwGarageRemove('${escAttr(key)}')">Remove it</button> and ` +
      (car.plate ? `search <strong>${escHtml(car.plate)}</strong> again` : `pick it from the <strong>Make, Model, Year</strong> list`) +
      ` for the current battery.`, "warning");
  }

  // Called from the markup above
  window.bwGarageUse = useGarageCar;
  window.bwGarageRemove = removeFromGarage;
  window.bwGarageClear = function () {
    if (!confirm("Remove every saved vehicle from this device?")) return;
    writeGarage([]);
    hideWidgetMessage();
  };

  function clearResults() {
    voteRef = null;
    document.getElementById("bwr-panel").style.display = "none";
    document.getElementById("bwr-help").style.display = "none";
    const url = new URL(window.location.href);
    ["fc", "v", "n"].forEach(k => url.searchParams.delete(k));
    history.pushState({}, "", url);
  }

  /**
   * Start over. Hiding the results but leaving Make, Model and Year filled in is the thing
   * that makes people think the widget is stuck, so this empties the lot.
   */
  function clearSearch() {
    clearResults();
    closeAllDropdowns();
    hideWidgetMessage();
    populateMakes();
    const plate = document.getElementById("bw-rego-input");
    if (plate) plate.value = "";
    regoKicker = "";
    searchKind = "manual";
    searchRef = null;
    pendingNotes = [];
    pendingLabel = "";
    pendingModel = "";
    pendingFitNote = "";
    pendingFacts = [];
    lastSearch = null;
    showClearButton();
    const first = document.getElementById("dd-btn-make");
    if (first) first.focus();
  }
  window.clearSearch = clearSearch;

  // Only offered once there is something to clear
  function showClearButton() {
    const btn = document.getElementById("bw-clear");
    if (!btn) return;
    const picked = !!(selectedValues.make || selectedValues.model || selectedValues.year);
    btn.style.display = picked ? "inline-flex" : "none";
  }

  /**
   * Bring the results into view WITHOUT scrolling past the widget itself – the customer
   * should still see My garage and the Make/Model/Year we filled in for them, because
   * that's how they check we got the right car. So we scroll to the top of the whole
   * widget, and only fall back to the results panel if the widget is too tall to fit.
   */
  function scrollToWidget(panel) {
    const box = panel.closest(".battery-widget-container") || panel;
    const gap = 16;                                    // a little breathing room above
    // A sticky header would otherwise sit over the top of the widget
    const stuck = [...document.querySelectorAll("header, .header, .site-header, .shopify-section-header, [role='banner']")]
      .filter(el => {
        const s = getComputedStyle(el);
        return (s.position === "fixed" || s.position === "sticky") && el.getBoundingClientRect().height < 200;
      })
      .reduce((h, el) => Math.max(h, el.getBoundingClientRect().height), 0);

    const room = window.innerHeight - stuck - gap;
    const boxTop = box.getBoundingClientRect().top;
    // What has to be on screen: everything from the top of the widget down to the
    // "Batteries to suit" heading – the garage, the tabs, and the Make/Model/Year.
    const head = panel.querySelector(".bwr-head") || panel;
    const needed = head.getBoundingClientRect().bottom - boxTop;

    // Only skip ahead to the results when all of that can't fit on the screen at once
    const target = needed > room ? panel : box;
    const top = window.scrollY + target.getBoundingClientRect().top - stuck - gap;
    window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
  }

  /* ---------- results ---------- */
  const money = cents => new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" }).format((cents || 0) / 100);
  const sizedImg = (src, w) => src ? (src.startsWith("//") ? "https:" + src : src) + (src.includes("?") ? "&" : "?") + "width=" + w : "";
  let resultsRequest = 0;
  let productSpecs = {};               // handle -> { length, width, height, totalHeight, weight }
  let foundProducts = [];              // what the current search returned, before sorting
  let haveLocationData = false;        // did this search get any per-shop stock back at all?
  let sortMode = "recommended";
  // Whether the feed we got back was ordered by how much each battery sells. Shopify's search
  // orders by relevance and takes no sort, so when the products come from there we have no
  // popularity to sort on and the "Most bought" option is not offered at all - an order that
  // means nothing is worse than no option.
  let popularityKnown = true;
  let regoKicker = "";                         // "Found from rego ..." line for the next results
  let lastSearch = null;
  let pendingFacts = [];

  function retryResults() {
    if (!lastSearch) return;
    renderResults(lastSearch.codes, lastSearch.label, lastSearch.notes, false);
  }
  window.retryResults = retryResults;

  function showFacts(list) {
    const host = document.getElementById("bwr-head");
    if (!host) return;
    let el = document.getElementById("bwr-facts");
    if (!el) {
      el = document.createElement("div");
      el.id = "bwr-facts";
      el.className = "bwr-facts";
      host.appendChild(el);
    }
    const bits = (list || []).filter(f => f && f.value);
    el.innerHTML = bits.map(f =>
      `<div class="bwr-fact"><span class="bwr-fact-label">${escHtml(f.label)}</span>` +
      `<span class="bwr-fact-value">${escHtml(f.value)}</span></div>`).join("");
    el.style.display = bits.length ? "grid" : "none";
  }

  async function renderResults(codes, vehicleLabel, notes, scroll = true) {
    const req = ++resultsRequest;
    lastSearch = { codes, label: vehicleLabel, notes };
    const panel = document.getElementById("bwr-panel");
    const grid = document.getElementById("bwr-grid");
    const status = document.getElementById("bwr-status");
    const warnEl = document.getElementById("bwr-warn");

    hideWidgetMessage();
    panel.style.display = "block";
    // The year has a field of its own below, so it no longer trails the name in brackets
    const yearSaid = (pendingFacts.find(f => f.label === "Year") || {}).value;
    let heading = vehicleLabel || "Your vehicle";
    if (yearSaid && heading.slice(-(String(yearSaid).length + 3)) === " (" + yearSaid + ")") {
      heading = heading.slice(0, -(String(yearSaid).length + 3));
    }
    document.getElementById("bwr-vehicle").textContent = heading;
    document.getElementById("bwr-kicker").textContent = regoKicker || "Batteries to suit";
    showFitNote(pendingFitNote);
    pendingFitNote = "";
    showQtyNote(pendingQty);
    pendingQty = 1;
    regoKicker = "";
    showVote();
    showTeamNotes(pendingTeamNotes);
    showFacts(pendingFacts.concat(codes.length ? [{ label: "Fits", value: codes.join(", ") }] : []));
    pendingFacts = [];
    if (notes.length) {
      document.getElementById("bwr-warn-list").innerHTML = notes.map(n => `<li>${escHtml(n)}</li>`).join("");
      warnEl.style.display = "flex";
    } else warnEl.style.display = "none";
    status.innerHTML = "Finding batteries for your vehicle…";
    productSpecs = {};
    document.getElementById("bwr-help-btn").href = CONTACT_URL;
    document.getElementById("bwr-help").style.display = "none";   // only shown once the search has finished
    grid.innerHTML = skeletonHtml(3);
    if (scroll) scrollToWidget(panel);

    try {
      const products = USE_THEME_FEED
        ? await productsFromTheme(codes)
        : await productsFromWorker(codes);
      if (req !== resultsRequest) return;                 // a newer search has started

      if (!products.length) {
        status.innerHTML = "";
        grid.innerHTML = emptyHtml(
          "We don't have this one on the website",
          "We know the vehicle, we just haven't listed a battery against it online yet. Give us a ring and we'll tell you exactly what fits and have it ready for you.");
        showHelpBanner();
        return;
      }
      // Shopify only lists a shop when it actually holds the battery, so "missing" means
      // "none here". If NO battery came back with any shop at all, the shop lookup isn't
      // working on this store and we show the plain in-stock line instead of false crosses.
      haveLocationData = products.some(p => (p.variants || []).some(v => (v.locations || []).length));
      foundProducts = products;
      status.innerHTML = statusBar(products.length);
      drawProducts();
      showHelpBanner();
    } catch (err) {
      if (req !== resultsRequest) return;
      console.error("Results error:", err);
      status.innerHTML = "";
      grid.innerHTML = emptyHtml(
        "We couldn't load the batteries just now",
        "That's our end, not yours. Try the search again in a moment, or give us a call and we'll sort it out for you.",
        true);
      showHelpBanner();
    }
  }

  function showHelpBanner() { document.getElementById("bwr-help").style.display = "flex"; }

  function skeletonHtml(n) {
    const card = `<div class="bwr-sk-card">
      <div class="bwr-sk-line bwr-sk-img"></div>
      <div class="bwr-sk-line bwr-sk-sm"></div>
      <div class="bwr-sk-line bwr-sk-md"></div>
      <div class="bwr-sk-line bwr-sk-lg"></div>
      <div class="bwr-sk-line bwr-sk-btn"></div>
    </div>`;
    return `<div class="bwr-skeleton" aria-hidden="true">${card.repeat(n)}</div>`;
  }

  function emptyHtml(title, text, retry) {
    return `<div class="bwr-empty" role="status">
      <p class="bwr-empty-title">${escHtml(title)}</p>
      <p class="bwr-empty-text">${escHtml(text)}</p>
      <div class="bwr-empty-acts">
        ${retry ? '<button type="button" class="bw-btn bw-btn-ghost" onclick="retryResults()">Try again</button>' : ""}
        <a class="bw-btn" href="${escHtml(PHONE_LINK)}">Call ${escHtml(PHONE_NUMBER)}</a>
        <a class="bw-btn bw-btn-ghost" href="${escHtml(CONTACT_URL)}">Contact us <span class="bwr-arrow" aria-hidden="true">&rarr;</span></a>
      </div>
    </div>`;
  }

  // Straight from the theme – one request per fitment code, metafields included
  async function productsFromTheme(codes) {
    const seen = {};
    // A feed that fails to load, or comes back as something other than JSON, is not the same
    // as a fitment code with no batteries on it. Telling them apart matters: one sends the
    // team looking for a missing product, the other for a broken page.
    let broken = 0, unfiltered = 0;

    // One fitment code: ask each way Shopify offers and stop at the first that really filtered.
    async function askFor(code) {
      const urls = FEED_URLS(code);
      let lastUnfiltered = null;
      for (const url of urls) {
        let feed;
        try {
          const res = await fetch(url, { cache: "no-store" });
          if (!res.ok) throw new Error("HTTP " + res.status);
          const text = await res.text();
          try { feed = JSON.parse(text); }
          catch (err) {
            const liquid = text.match(/Liquid error[^"\n]{0,160}/);
            console.error("The fitment feed for " + code + " isn't valid JSON." +
              (liquid ? " Shopify says: " + liquid[0] : "") + " (" + url + ")");
            continue;
          }
        } catch (err) { console.error("Fitment feed " + code + ":", err.message, url); continue; }
        // A feed that never filtered is the whole catalogue, not a list of batteries that fit,
        // so it is never shown. The template reports the tag it actually used.
        if (feed && feed.filtered === false) { lastUnfiltered = feed; continue; }
        return feed;
      }
      if (lastUnfiltered) { unfiltered++; return null; }
      broken++;
      return null;
    }

    const feeds = await Promise.all(codes.map(askFor));
    // Only the collection feeds carry sort_by=best-selling; search hands back relevance order.
    popularityKnown = feeds.some(Boolean) && feeds.every(f => !f || f.source !== "search");
    // Nothing answered at all, or nothing Shopify was willing to filter: that is a broken feed,
    // not a battery we don't stock. Saying "we haven't listed one" here would tell every
    // customer on the site we have nothing for their car.
    if (codes.length && broken + unfiltered === codes.length) {
      console.error("No fitment feed filtered for any of: " + codes.join(", ") +
        " - none of the product feed addresses worked on this store");
      throw new Error("fitment_feed_unavailable");
    }
    for (const feed of feeds) {
      if (!feed) continue;
      const list = (feed && feed.products) || [];
      list.forEach((p, i) => {
        // Feeds come back best-selling first, so position = how popular it is
        p.rank = seen[p.handle] ? Math.min(seen[p.handle].rank, i) : i;
      });
      for (const p of list) {
        if (seen[p.handle]) { seen[p.handle].rank = Math.min(seen[p.handle].rank, p.rank); continue; }
        seen[p.handle] = p;
        const spec = {
          length: p.length_mm || "", width: p.width_mm || "", height: p.height_mm || "",
          totalHeight: p.total_height_mm || "", weight: p.weight_kg || "",
          cca: p.cca || "", ah: p.ah || "", ah5: p.ah5 || "", ah20: p.ah20 || "",
        };
        if (Object.values(spec).some(Boolean)) productSpecs[p.handle] = spec;
      }
    }
    return Object.values(seen);
  }

  // Older route: the Worker says which handles match, then Shopify gives the details
  async function productsFromWorker(codes) {
    const res = await fetch(withCode(`${PRODUCTS_URL}?fc=${encodeURIComponent(codes.join(","))}`), { cache: "no-store" });
    const data = await res.json();
    if (!data.success) throw new Error(data.error || "products_unavailable");
    productSpecs = data.specs || {};
    return (await Promise.all(data.handles.map(h =>
      fetch(`/products/${encodeURIComponent(h)}.js`, { cache: "no-store" }).then(r => r.ok ? r.json() : null).catch(() => null)
    ))).filter(Boolean);
  }

  const brandKey = s => String(s || "").toLowerCase().replace(/[^a-z0-9]/g, "");
  const BRAND_KEYS = BRAND_ORDER.map(brandKey);

  // Where this battery's brand sits in the preference list (lower = shown first)
  function brandRank(p) {
    const vendor = brandKey(p.vendor);
    let i = BRAND_KEYS.indexOf(vendor);
    if (i >= 0) return i;
    const title = brandKey(p.title);                 // fallback: brand named in the title
    i = BRAND_KEYS.findIndex(k => k.length >= 4 && title.includes(k));
    return i >= 0 ? i : BRAND_KEYS.length;
  }

  function sortProducts(list) {
    const out = [...list];
    const inStockFirst = (a, b) => (b.available ? 1 : 0) - (a.available ? 1 : 0);
    if (sortMode === "price-asc")  return out.sort((a, b) => inStockFirst(a, b) || a.price - b.price);
    if (sortMode === "price-desc") return out.sort((a, b) => inStockFirst(a, b) || b.price - a.price);
    if (sortMode === "popular")    return out.sort((a, b) => inStockFirst(a, b) || (a.rank || 0) - (b.rank || 0));
    // Recommended: in stock, then our brand order, then cheapest of that brand
    return out.sort((a, b) => inStockFirst(a, b) || brandRank(a) - brandRank(b) || a.price - b.price);
  }

  function changeSort(value) {
    sortMode = value;
    try { sessionStorage.setItem("bwSort", value); } catch (e) {}
    drawProducts();
  }

  function drawProducts() {
    const grid = document.getElementById("bwr-grid");
    const products = sortProducts(foundProducts);
    grid.innerHTML = products.map((p, i) => cardHtml(p, i)).join("");
    products.forEach(wireCard);
  }

  function statusBar(count) {
    const opts = [["recommended", "Recommended"], ["price-asc", "Price: low to high"],
                  ["price-desc", "Price: high to low"]];
    if (popularityKnown) opts.push(["popular", "Most bought"]);
    else if (sortMode === "popular") sortMode = "recommended";
    return `<span>${count} battery option${count === 1 ? "" : "s"} found</span>
      <span class="bwr-sort"><label for="bwr-sort-select">Sort by</label>
        <select id="bwr-sort-select" onchange="changeSort(this.value)">
          ${opts.map(([v, t]) => `<option value="${v}"${sortMode === v ? " selected" : ""}>${t}</option>`).join("")}
        </select></span>`;
  }

  function firstAvailable(p) { return p.variants.find(v => v.available) || p.variants[0]; }

  const CHEMISTRY = [[/\bagm\b/i, "AGM"], [/\befb\b/i, "EFB"], [/\bgel\b/i, "Gel"],
                     [/lithium|lifepo/i, "Lithium"], [/\bcalcium\b/i, "Calcium"]];

  // Taken from the fitment code and the product title, which is where our own naming puts it
  function chemistry(p) {
    const text = [p.fitment_code, p.title, p.vendor].filter(Boolean).join(" ");
    const hit = CHEMISTRY.find(([re]) => re.test(text));
    return hit ? hit[1] : "";
  }

  function pillFor(p, i) {
    if (p.oe_fit === true || String(p.oe_fit || "").toLowerCase() === "true") return "OE match";
    return i === 0 && sortMode === "recommended" && foundProducts.length > 1 ? "Our pick" : "";
  }

  function cardHtml(p, i) {
    const v = firstAvailable(p);
    const img = sizedImg(p.featured_image || (v.featured_image && v.featured_image.src), 400);
    const pill = pillFor(p, i);
    return `
      <div class="bwr-card" id="bwr-card-${p.id}">
        ${pill ? `<span class="bwr-pill">${escHtml(pill)}</span>` : ""}
        <a class="bwr-img" href="/products/${escHtml(p.handle)}">${img ? `<img src="${escHtml(img)}" alt="${escHtml(p.title)}" loading="lazy">` : ""}</a>
        <div class="bwr-vendor">${escHtml(p.vendor || "")}</div>
        <a class="bwr-name" href="/products/${escHtml(p.handle)}">${escHtml(p.title)}</a>
        <div class="bwr-money"><span class="bwr-price" data-price>${money(v.price)}</span><span class="bwr-compare" data-compare>${v.compare_at_price > v.price ? money(v.compare_at_price) : ""}</span></div>
        ${chipsHtml(p)}
        ${stockHtml(v)}
        ${specLine(p.handle)}
        ${p.variants.length > 1 ? `<select class="bwr-select" data-variant>${p.variants.map(x => `<option value="${x.id}" ${x.id === v.id ? "selected" : ""} ${x.available ? "" : "disabled"}>${escHtml(x.title)}${x.available ? "" : " – sold out"}</option>`).join("")}</select>` : ""}
        <div class="bwr-buy">
          <input class="bwr-qty" type="number" min="1" value="1" aria-label="Quantity" data-qty>
          <button type="button" class="bwr-add" data-add ${v.available ? "" : "disabled"}>${v.available ? "Add to cart" : "Sold out"}</button>
        </div>
        <div class="bwr-msg" data-msg></div>
      </div>`;
  }

  // The numbers a customer compares on: cranking amps, capacity, the group code and the
  // chemistry. Each one only appears when we actually hold it.
  function chipsHtml(p) {
    const s = productSpecs[p.handle] || {};
    const ah = s.ah || s.ah20 || s.ah5;
    const ahNote = !s.ah && s.ah20 ? " <span>20hr</span>" : (!s.ah && s.ah5 ? " <span>5hr</span>" : "");
    const chem = chemistry(p);
    const chips = [
      s.cca && `<span class="bwr-chip">${escHtml(s.cca)} <span>CCA</span></span>`,
      ah && `<span class="bwr-chip">${escHtml(ah)} <span>Ah</span>${ahNote}</span>`,
      p.fitment_code && `<span class="bwr-chip">${escHtml(String(p.fitment_code).split(",")[0].trim())}</span>`,
      chem && `<span class="bwr-chip">${escHtml(chem)}</span>`,
    ].filter(Boolean);
    return chips.length ? `<div class="bwr-chips">${chips.join("")}</div>` : "";
  }

  // Reference detail rather than a selling point, so it sits quietly under a hairline.
  // Each part stays on one line, and the overall height is only worth saying when it is
  // taller than the case itself.
  function specLine(handle) {
    const s = productSpecs[handle] || {};
    const num = v => String(v).replace(/\s*mm$/i, "").trim();
    const bits = [];
    if (s.length && s.width && s.height) bits.push(`${num(s.length)} \u00D7 ${num(s.width)} \u00D7 ${num(s.height)} mm`);
    if (s.totalHeight && num(s.totalHeight) !== num(s.height)) bits.push(`${num(s.totalHeight)} mm overall`);
    if (s.weight) bits.push(`${String(s.weight).replace(/\s*kg$/i, "").trim()} kg`);
    if (!bits.length) return "";
    return `<div class="bwr-spec">${bits.map(b => `<span>${escHtml(b)}</span>`).join("")}</div>`;
  }

  // Per-shop stock with a tick or cross. Falls back to plain In stock / Out of stock
  // when Shopify gives us no location breakdown for this battery.
  function stockHtml(variant) {
    const locs = Array.isArray(variant.locations) ? variant.locations : [];
    if (!haveLocationData) {
      return `<div class="bwr-stock ${variant.available ? "bwr-in" : "bwr-out"}" data-stock>${variant.available ? "In stock" : "Out of stock"}</div>`;
    }

    const matched = new Set();
    const rows = STOCK_LOCATIONS.map(cfg => {
      if (cfg.useOverall) return { label: cfg.label, title: cfg.label, available: !!variant.available };
      const hit = locs.find(l => normKey(l.name).includes(normKey(cfg.match)));
      if (hit) matched.add(hit.name);
      // Not listed by Shopify = this shop doesn't hold it
      return { label: cfg.label, title: hit ? hit.name : cfg.label, available: !!(hit && hit.available) };
    });

    // Any other shop that came back and isn't in the list above
    for (const l of locs) {
      if (matched.has(l.name)) continue;
      if (STOCK_LOCATIONS.some(cfg => normKey(l.name).includes(normKey(cfg.match)))) continue;
      rows.push({ label: l.name, title: l.name, available: !!l.available });
    }

    return `<div class="bwr-stock-list" data-stock>${rows.map(r => {
      const qty = Number(r.quantity);
      const count = Number.isFinite(qty) && qty > 0 ? `: ${qty}` : "";
      return `<div class="bwr-loc ${r.available ? "bwr-loc-yes" : "bwr-loc-no"}" title="${escHtml(r.title)}">
        <span class="bwr-loc-mark" aria-hidden="true">${r.available ? "&#10003;" : "&#10007;"}</span>
        <span class="bwr-loc-name">${escHtml(r.label)}${count}</span></div>`;
    }).join("")}</div>`;
  }

  function wireCard(p) {
    const card = document.getElementById(`bwr-card-${p.id}`);
    const sel = card.querySelector("[data-variant]");
    const btn = card.querySelector("[data-add]");
    const msg = card.querySelector("[data-msg]");
    let variant = firstAvailable(p);

    if (sel) sel.addEventListener("change", () => {
      variant = p.variants.find(x => String(x.id) === sel.value) || variant;
      card.querySelector("[data-price]").textContent = money(variant.price);
      card.querySelector("[data-compare]").textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price) : "";
      const stock = card.querySelector("[data-stock]");
      if (stock) stock.outerHTML = stockHtml(variant);
      btn.disabled = !variant.available;
      btn.textContent = variant.available ? "Add to cart" : "Sold out";
    });

    btn.addEventListener("click", async () => {
      const qty = Math.max(1, parseInt(card.querySelector("[data-qty]").value, 10) || 1);
      btn.disabled = true; btn.textContent = "Adding…"; msg.textContent = "";
      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: qty }] })
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || "Couldn't add to cart");
        btn.textContent = "Added to cart";
        reportEvent("add_to_cart", p.fitment_code || "", qty);
        tagCart();
        showToast(`${qty} × ${p.title} added to cart`);
        refreshCartCount();
        setTimeout(() => { btn.textContent = "Add to cart"; btn.disabled = false; }, 1500);
      } catch (err) {
        msg.textContent = err.message;
        btn.textContent = "Add to cart";
        btn.disabled = false;
      }
    });
  }

  function showToast(text) {
    document.getElementById("bwr-toast-msg").textContent = text;
    document.getElementById("bwr-toast").style.display = "flex";
    clearTimeout(showToast.t);
    showToast.t = setTimeout(() => { document.getElementById("bwr-toast").style.display = "none"; }, 6000);
  }

  // Update the theme's cart counter (covers the common theme selectors)
  async function refreshCartCount() {
    try {
      const cart = await (await fetch("/cart.js", { cache: "no-store" })).json();
      document.querySelectorAll(".cart-count-bubble span[aria-hidden='true'], [data-cart-count], .cart-count, .cart-item-count, #CartCount")
        .forEach(el => { el.textContent = cart.item_count; });
      document.dispatchEvent(new CustomEvent("cart:refresh", { detail: cart }));
    } catch (e) { /* counter is cosmetic */ }
  }

  /* ---------- rego search ---------- */
  function resolveMakes(apiMake) {
    const raw = String(apiMake || "").trim();
    if (!raw) return [];

    // The alias lists are written most-likely-first - "MINI" is a Mini before it is a
    // Leyland - so the answer keeps that order rather than the guide's alphabetical one.
    // Everything downstream treats the first make as the one to show.
    const lookup = list => {
      const out = [];
      for (const want of list.map(normKey).filter(Boolean))
        for (const m of makesList)
          if (normKey(m) === want && !out.includes(m)) out.push(m);
      return out;
    };

    // A rule set in the portal is the last word. The built-in list only adds to the name we
    // were given, so a make that really is in the guide under that exact name is never
    // skipped – a row filed under "MERCEDES-BENZ" still comes back alongside our "Mercedes".
    const widen = (name, key) => portalAliases[key] || (MAKE_ALIASES[key] ? [name, ...MAKE_ALIASES[key]] : [name]);

    // 1. The portal's own rules first, then the built-in list, then the make as given
    const upper = raw.toUpperCase();
    let hit = lookup(widen(raw, upper));
    if (hit.length) return hit;

    // 2. Same again with the padding words stripped ("ISUZU UTE" -> "ISUZU")
    const cleaned = upper.replace(MAKE_NOISE, " ").replace(/\s+/g, " ").trim();
    if (cleaned && cleaned !== upper) {
      hit = lookup(widen(cleaned, cleaned));
      if (hit.length) return hit;
    }

    // 3. Last resort so a missing alias never dead-ends: one guide make is clearly
    //    the same badge ("VOLKSWAGEN GOLF R" -> Volkswagen). Four characters
    //    minimum on both sides, so "AC" can't swallow "ACURA".
    const key = normKey(cleaned || upper);
    if (key.length >= 4) {
      hit = makesList.filter(m => {
        const k = normKey(m);
        return k.length >= 4 && (k === key || k.startsWith(key) || key.startsWith(k));
      });
      if (hit.length) return hit;
    }
    return [];
  }

  // Body shapes. Two vocabularies on purpose:
  //
  // API_BODY – what the rego database calls them, including the manufacturers' own names
  //   for a wagon. "C-CLASS TOURING" is a C Class wagon.
  // ROW_BODY – only the words OUR guide uses as a body descriptor. Deliberately narrower,
  //   because "Camry 2.4i Touring" and "Volkswagen Kombi" are model names, not shapes,
  //   and reading those as "wagon" would push the right row down.
  const API_BODY = {
    wagon: ["wagon", "touring", "estate", "avant", "variant", "tourer", "sportwagon"],
    sedan: ["sedan", "saloon"], coupe: ["coupe"],
    convertible: ["convertible", "cabriolet", "cabrio", "roadster"],
    hatch: ["hatch", "hatchback"], van: ["van"],
    ute: ["ute", "utility", "pickup"],
  };
  // "avant" is safe here – in our guide it only ever appears on genuine Audi wagons.
  // "touring" is not: it's a Camry and a Lotus trim level as well as a BMW wagon.
  const ROW_BODY = {
    wagon: ["wagon", "avant"], sedan: ["sedan", "saloon"], coupe: ["coupe"],
    convertible: ["convertible", "cabriolet", "roadster"],
    hatch: ["hatch", "hatchback"], van: ["van"],
    ute: ["ute", "utility", "pickup"],
  };
  const flip = map => {
    const out = {};
    for (const [body, list] of Object.entries(map)) for (const w of list) out[w] = body;
    return out;
  };
  const API_BODY_OF = flip(API_BODY), ROW_BODY_OF = flip(ROW_BODY);

  // Which body shape a piece of text names, if any
  const bodyOf = (text, table) => {
    if (/cab chassis/i.test(text)) return "ute";
    for (const w of words(text)) if (table[w]) return table[w];
    return "";
  };

  // Returns [{ make, model, year, notes }] – the rows that best fit the rego result
  let nameOnlyHits = [];

  function findModelMatches(makes, v) {
    nameOnlyHits = [];
    const allRows = makes.flatMap(rowsFor);
    // What shape is this car? The model name wins over bodyType, because the rego
    // database is more specific there ("C-CLASS TOURING" vs a bodyType of "WAGON").
    const wantBody = bodyOf(v.model, API_BODY_OF) || bodyOf(v.bodyType, API_BODY_OF);

    // 1. Narrow by MODEL first – the strongest signal. Whole-word matching, so a model
    //    called "3" doesn't match "CX-7 Petrol 2.3i".
    const makeWords = new Set(makes.flatMap(m => words(m)));
    const apiWords = words(v.model).filter(w => !makeWords.has(w));
    // "Treat this model as…": the built-in list, plus anything the team has added in the
    // portal against one of these makes. Those are held per make, so a spelling added for
    // Toyota can never pull in another badge's model. Both are additive - the sets are only
    // tried when the name as given finds nothing, so an entry here cannot take a working
    // match away.
    const modelKey = String(v.model || "").trim().toUpperCase();
    const aliasNames = (MODEL_ALIASES[modelKey] || []).slice();
    for (const m of makes) {
      const rules = portalModelAliases[String(m).trim().toUpperCase()];
      for (const name of (rules && rules[modelKey]) || [])
        if (!aliasNames.includes(name)) aliasNames.push(name);
    }
    const aliasSets = aliasNames
      .map(n => words(n).filter(w => !makeWords.has(w)))
      .filter(w => w.length);

    // A row word counts as the one we were given when it is the same word, or – only for a
    // family name like "GLA-CLASS" or "3 SERIES" – when it is that word with the badge
    // number stuck on the end: "GL" fits "GL500", "3" fits "320i", but "GL" never fits "GLA".
    const sameWord = (rw, w, badge) =>
      rw === w || (badge && !!rw && rw.length > w.length && rw.indexOf(w) === 0 && /\d/.test(rw.charAt(w.length)));

    const narrow = (wanted, badge) => allRows.filter(r => {
      const rw = words(r.model);
      if (wanted.length && wanted.every(w => rw.some(x => sameWord(x, w, badge)))) return true;
      return rw.length && rw[0].length >= 4 && wanted.some(w => sameWord(rw[0], w, badge));   // e.g. "RANGE ROVER SPORT" -> "Sport Petrol 5.0i"
    });

    // "GLA-CLASS", "3 SERIES", "M-CLASS" – the rego database names the family and puts the
    // badge in the grade, while our guide names the badge ("GL500 Petrol", "320i Sedan").
    // So for a family name the grade is the better place to start.
    const familyWords = apiWords.filter(w => w !== "class" && w !== "series");
    const hasFamily = familyWords.length > 0 && familyWords.length < apiWords.length;
    // "320i", "C43", "ML350" – a badge carries both letters and digits, which keeps plain
    // trim names like GLS or Linear out of it. These are matched on whole chunks rather than
    // our usual word split, because "C43" has to stay in one piece to find "… Petrol C43 AMG".
    const glued = str => String(str || "").toLowerCase().match(/[a-z0-9]+/g) || [];
    const noEngine = str => String(str || "").replace(/\b\d+\.\d+[a-z]*/gi, " ");
    const badgeWords = hasFamily
      ? glued(noEngine(v.grade)).filter(w => /[a-z]/.test(w) && /\d/.test(w) && !makeWords.has(w))
      : [];
    // "E350 CDI" from the rego and "E350CDi" in our guide are the same car, but one is two
    // chunks and the other is one, so an exact chunk match never finds it. A badge also fits
    // a longer chunk that starts with it and carries only letters after - "E350" fits
    // "E350CDi" and "C43" fits "C43AMG" - and the same the other way round. Letters only, so
    // "E350" can never reach "E3500".
    const badgeFits = (chunk, want) => {
      if (chunk === want) return true;
      if (chunk.length > want.length && chunk.indexOf(want) === 0) return /^[a-z]+$/.test(chunk.slice(want.length));
      if (want.length > chunk.length && want.indexOf(chunk) === 0 && /\d/.test(chunk)) return /^[a-z]+$/.test(want.slice(chunk.length));
      return false;
    };
    const narrowBadge = wanted => allRows.filter(r => {
      const rw = glued(r.model);
      return wanted.every(w => rw.some(x => badgeFits(x, w)));
    });

    const withoutBody = apiWords.filter(w => !API_BODY_OF[w]);
    const bodyStripped = withoutBody.length > 0 && withoutBody.length < apiWords.length;

    // In order: the badge from the grade, the model as given, the model without its body
    // word, then the family name on its own with the badge number allowed on the end.
    let want = apiWords, badge = false, hits = [];
    // The badge is specific enough on its own, so when it matches there is nothing left
    // for the start-of-the-name rule below to narrow.
    let onBadge = false;
    if (badgeWords.length) {
      hits = narrowBadge(badgeWords);
      if (hits.length) onBadge = true;
    }
    // An import name and our name for the same vehicle are gathered together, so the year
    // and engine choose between them rather than the spelling
    if (!hits.length && aliasSets.length) {
      const seen = new Set();
      for (const set of [apiWords].concat(aliasSets)) {
        for (const r of narrow(set, false)) if (!seen.has(r)) { seen.add(r); hits.push(r); }
      }
      if (hits.length) onBadge = true;
    }
    if (!hits.length) {
      const tries = [[apiWords, false]];
      if (bodyStripped) tries.push([withoutBody, false]);
      if (hasFamily) tries.push([familyWords, true]);
      for (const [wanted, b] of tries) {
        if (!wanted.length) continue;
        hits = narrow(wanted, b);
        if (hits.length) { want = wanted; badge = b; break; }
      }
    }
    // Nothing matched on whole words – fall back to a looser check rather than showing nothing
    if (!hits.length) {
      const keys = [normKey(v.model)];
      if (bodyStripped) keys.push(normKey(withoutBody.join(" ")));
      if (hasFamily) keys.push(normKey(familyWords.join(" ")));
      for (const k of keys) {
        if (!k) continue;
        hits = allRows.filter(r => normKey(r.model).includes(k) || k.includes(normKey(r.model)));
        if (hits.length) break;
      }
      // No model name at all (some older rego records) – let the year do the narrowing
      if (!hits.length && !keys.some(Boolean)) hits = allRows.slice();
    }
    if (!hits.length) return [];

    // 1b. The model name has to START with what we were given, once the make is
    //     stripped off the front: a Mazda "3" is "Mazda 3 2.0i", never "CX-3 Petrol 2.0i".
    if (want.length && !onBadge) {
      const strong = hits.filter(r => {
        const rw = words(r.model);
        let i = 0;
        while (i < rw.length && makeWords.has(rw[i])) i++;      // skip "Mazda" in "Mazda 3"
        return want.every((w, n) => sameWord(rw[i + n], w, badge));
      });
      if (strong.length) hits = strong;
    }

    // What matched on the name alone. If the year then rules every one of them out, this is
    // what lets the Model list show just that model's entries instead of the whole make.
    nameOnlyHits = hits.slice();

    // 2. Then narrow by YEAR within that model – build month first, then the whole year.
    //    If the vehicle is just outside every row for that model (a 2024 Triton against rows
    //    ending 2023), keep the model rows rather than throwing them all away. Two years is
    //    the limit: a 2008 Saab against rows ending 2002 is a different generation, and a
    //    wrong battery is worse than telling the customer it isn't in the guide yet.
    // A commercial row names its vehicle by model code – FRR107-210, K100 / K104 / K108 –
    // and is often built over a span nobody wrote down. Where the truck or plant guide has
    // left the years blank, the row covers every year rather than none. Cars are not given
    // that licence: there a blank year is a mistake, and the wrong generation is the wrong
    // battery.
    const openEnded = openEndedRow;
    const yearFits = (r, strict) => openEnded(r) || yearMatches(r.year, v.year, v.compliance, strict);

    const exact = hits.filter(r => yearFits(r, true));
    const loose = hits.filter(r => yearFits(r, false));
    if (exact.length) hits = exact;
    else if (loose.length) hits = loose;
    else if (v.year) hits = hits.filter(r => openEnded(r) || yearNear(r.year, v.year, 2));

    // Grouped by the name the customer will see, so a GLA180 row and a GLA250 row stay apart.
    // Generations are kept apart too: two rows can share a name and still be different cars
    // with different batteries, told apart by the years they cover.
    const byModel = {};
    hits.forEach(r => { const k = modelName(r) + "\u0000" + (r.year || ""); (byModel[k] = byModel[k] || []).push(r); });

    // Two generations can still come out under one name. Where they also disagree on the
    // battery and each carries its own series code, the series goes in the name: showing the
    // same name twice, or one name with two batteries, gives the customer nothing to go on.
    const codesOfGroup = rs => [...new Set(rs.flatMap(r => String(r.fitmentCode || "")
      .split(",").map(c => c.trim().toUpperCase()).filter(Boolean)))].sort().join("|");
    const renamed = {};
    const byLabel = {};
    Object.keys(byModel).forEach(k => {
      const l = k.split("\u0000")[0];
      (byLabel[l] = byLabel[l] || []).push(k);
    });
    for (const keys of Object.values(byLabel)) {
      if (keys.length < 2) continue;
      if (new Set(keys.map(k => codesOfGroup(byModel[k]))).size < 2) continue;
      const series = keys.map(k => String((byModel[k][0] || {}).series || "").trim());
      if (series.some(x => !x)) continue;
      if (new Set(series.map(x => x.toLowerCase())).size !== keys.length) continue;
      keys.forEach(k => { renamed[k] = modelNameWithSeries(byModel[k][0]); });
    }

    const scored = Object.entries(byModel).map(([key, rs]) => {
      const label = renamed[key] || key.split("\u0000")[0];
      // Scored on the model name alone – the grade has its own test further down, and
      // counting it twice would let a wordy grade outweigh the fuel and engine checks
      const model = String(rs[0].model || "");
      const t = model.toLowerCase();
      let s = 0;
      const saysDiesel = /diesel|\d\.\d+d/.test(t), saysPetrol = /petrol/.test(t);
      const wrongFuel = (v.fuel === "Diesel" && saysPetrol) || (v.fuel === "Petrol" && saysDiesel);
      // Only a row that names one fuel and not the other contradicts the car. Plenty of rows
      // cover both - "X4 Diesel & Petrol", "Allroad Diesel & Petrol" - and those fit either way.
      const onlyOtherFuel = (v.fuel === "Diesel" && saysPetrol && !saysDiesel)
                         || (v.fuel === "Petrol" && saysDiesel && !saysPetrol);
      if (v.fuel === "Diesel") s += saysDiesel ? 2 : (saysPetrol ? -5 : 0);
      if (v.fuel === "Petrol") s += saysPetrol ? 2 : (saysDiesel ? -5 : 0);
      if (v.engineLitres && !wrongFuel) {          // engine size never rescues the wrong fuel
        const engines = t.match(/\d\.\d(?=[a-z]|\b)/g);
        if (engines) s += engines.includes(v.engineLitres) ? 3 : -2;
      }
      // Grade / trim from the rego result, e.g. GLS, VX, Sportivo
      const gradeWords = words(v.grade).filter(w => w.length >= 2);
      if (gradeWords.length) {
        const modelWords = words(model);
        if (gradeWords.every(w => modelWords.includes(w))) s += 3;
      }
      const modelWords = words(model);

      // The guide's own Grade column, where someone has filled it in. Most rows haven't got
      // one and must never be punished for that – an empty grade simply says nothing. But a
      // row that does name a grade is a deliberate statement by the team, so matching it
      // beats everything else here, and contradicting it rules the row out.
      const rowGrades = [...new Set(rs.map(r => String(r.grade || "").trim()).filter(Boolean))];
      if (rowGrades.length && v.grade) {
        const theirs = new Set(glued(v.grade));
        const hit = rowGrades.some(g => { const parts = glued(g); return parts.length && parts.every(w => theirs.has(w)); });
        s += hit ? 6 : -6;
      }

      // Series code (VE, GDJ150R, PX) – in the series column or in the model name itself
      if (v.series) {
        const vs = normKey(v.series);
        const inColumn = rs.some(r => { const cs = normKey(r.series); return cs.length >= 2 && (cs.includes(vs) || vs.includes(cs)); });
        // The part of a series code that carries the digits is the telling part:
        // "ZRE182R" should beat "ZRE172R", not tie with it on the shared "ZRE".
        let inName = 0;
        words(v.series).filter(w => w.length >= 2).forEach(w => {
          if (modelWords.includes(w)) inName += /\d/.test(w) ? 3 : 1;
        });
        if (inName) s += Math.max(3, inName); else if (inColumn) s += 1;
      }

      // Body shape. Our guide writes it at the end of the model name ("… wagon"), the
      // rego database puts it in bodyType and sometimes in the model ("C-CLASS TOURING").
      // A row that names a body only fits a vehicle of that body; a row that names none
      // fits them all, so it is never penalised.
      const rowBody = bodyOf(t, ROW_BODY_OF);
      if (rowBody && wantBody) {
        if (rowBody === wantBody) s += rowBody === "ute" ? 2 : 3;
        else s += rowBody === "ute" || wantBody === "ute" ? -4 : -3;
      }

      // Transmission, where the guide distinguishes them
      if (v.transmission) {
        const auto = /auto/i.test(v.transmission), manual = /manual/i.test(v.transmission);
        if (/auto trans|automatic/.test(t)) s += auto ? 2 : -3;
        if (/\bmanual\b/.test(t)) s += manual ? 2 : -3;
      }

      // Fleet-only entries shouldn't win a tie against the normal model
      if (/police|taxi|fleet/.test(t) && !/police|taxi|fleet/i.test(v.grade || "")) s -= 2;

      // An auxiliary/second battery is an add-on, not the battery most customers came for
      if (/auxiliary|aux\.|back-up|backup|second battery/.test(t)) s -= 3;
      return { make: rs[0].make, model: label, year: rs[0].year, rows: rs, notes: rs.map(r => r.notes).filter(Boolean).join("; "), s, onlyOtherFuel };
    });

    // A row that names the other fuel isn't a worse answer, it's a different car. Scoring it
    // down only helps when there is something better to pick - when it is the only row left it
    // still wins, and a diesel gets sold the petrol battery. So it is dropped outright, and if
    // nothing survives we tell the customer we haven't listed one rather than sell them the
    // wrong one. Petrol against diesel only: the rego database calls a mild hybrid Hybrid
    // while our rows call it petrol, and those have to keep matching.
    const usable = scored.filter(x => !x.onlyOtherFuel);
    if (!usable.length) return [];
    const best = Math.max(...usable.map(x => x.s));
    return usable.filter(x => x.s === best);
  }

  async function submitRegoSearchInterim() {
    hideWidgetMessage();
    const rego = document.getElementById("bw-rego-input").value.trim().toUpperCase();
    const stateSelect = document.getElementById("bw-rego-state");
    const state = stateSelect ? stateSelect.value : "VIC";
    const btn = document.getElementById("bw-rego-btn");

    if (regoOff) { showWidgetMessage(escHtml(regoOffMessage || "Registration search is temporarily unavailable. Please search by Make, Model and Year below."), "warning"); return; }
    if (!rego) { showWidgetMessage("Please enter a registration plate.", "warning"); return; }

    const plate = rego.replace(/[^A-Z0-9]/g, "");
    if (!plate || plate.length > 9) { showWidgetMessage("Please check the registration plate and try again.", "warning"); return; }
    const national = state === "NHVR";
    if (!national && SEARCH_STATES.indexOf(state) < 0) { showWidgetMessage("Please choose the state the vehicle is registered in.", "warning"); return; }

    if (redirectMode()) {
      btn.innerText = "Searching...";
      btn.disabled = true;
      if (sendToResultsPage({ state: state, rego: plate, type: "car" })) return;
      btn.innerText = "Find Battery";
      btn.disabled = false;
    }

    if (!dataReady) { showWidgetMessage("Still loading vehicle data – please try again in a moment.", "info"); return; }

    btn.innerText = "Searching...";
    btn.disabled = true;

    try {
      const response = await fetch(CLOUDFLARE_WORKER_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ rego, state: national ? "" : state, category: regoCategory(), code: getAccessCode() }),
        cache: "no-store"
      });
      const result = await response.json();

      if (!result.success) {
        if (result.error === "rego_off") {
          setRegoOff(result.message);
          showWidgetMessage(escHtml(result.message || "Registration search is temporarily unavailable. Please search by Make, Model and Year below."), "warning");
        } else if (result.error === "not_a_car") {
          showWidgetMessage(`That registration is for a <strong>${escHtml(result.vehicleType)}</strong>. We can only look up cars at the moment – please use the <strong>Make, Model, Year</strong> tab.`, "warning");
        } else if (result.error === "category_not_enabled") {
          showWidgetMessage(`We can't look up heavy vehicle plates just yet. Please use the <strong>Make, Model, Year</strong> tab.`, "warning");
        } else if (result.error === "rate_limited") {
          showCodeLink();
          showWidgetMessage(`You've reached the daily limit for rego searches. Please try again ${escHtml(result.retryAfter || "tomorrow")}, or search by <strong>Make, Model, Year</strong> below. Trade customers can enter their code underneath.`, "warning");
        } else if ((result.error === "not_found" || result.error === "invalid_rego") && regoCategory() === "truck") {
          showWidgetMessage(national
            ? `We couldn't find <strong>${escHtml(rego)}</strong> on the national heavy vehicle register. Plenty of trucks are registered with a state instead – choose the state on the plate and try again, or search by <strong>Make, Model, Year</strong>.`
            : `We couldn't find <strong>${escHtml(rego)}</strong> in ${escHtml(state)}. Please check the plate and state, try <strong>NHVR</strong> if it's nationally registered, or search by <strong>Make, Model, Year</strong>.`, "warning");
        } else if (result.error === "not_found" || result.error === "invalid_rego") {
          showWidgetMessage(`We couldn't find <strong>${escHtml(rego)}</strong> in ${escHtml(state)}. Please check the plate and state, or search by <strong>Make, Model, Year</strong>.`, "warning");
        } else {
          showWidgetMessage("Unable to query the registration database right now. Please search using the <strong>Make, Model, Year</strong> tab.", "error");
        }
        return;
      }

      await applyRegoResult(result.vehicle, result.logRef || null, rego, state);
    } catch (err) {
      console.error("Rego Lookup Error:", err);
      showWidgetMessage("Unable to query the registration database right now. Please search using the <strong>Make, Model, Year</strong> tab.", "error");
    } finally {
      btn.innerText = "Find Battery";
      btn.disabled = false;
    }
  }

  // Everything that happens once we know what the car is. Shared by a live rego search and
  // by a replay of one, so both reach exactly the same answer.
  async function applyRegoResult(v, logRef, rego, state) {
      const label = `${escHtml(v.year)} ${escHtml(v.make)} ${escHtml(v.model)}`;
      voteRef = null;
      const makes = resolveMakes(v.make);
      // So the plate and the build year get saved alongside the vehicle once the batteries show
      if (!replayMode) lastPlate = { rego, state, at: Date.now(), built: String(v.year || "") };
      searchKind = "rego";
      searchRef = logRef;

      if (!makes.length) {
        // The rego database uses a badge our guide files under another name. Don't
        // dead-end – hand them the Vehicle tab with every make ready to pick.
        reportMatch(logRef, (v.likelyCar === false && !truckGuideOn()) ? "not_a_car" : "no_make");
        reportEvent("no_results", "");
        if (v.likelyCar === false && !truckGuideOn()) { showWidgetMessage(notInGuideMessage(v, label), "warning"); return; }
        regoKicker = `Found from rego ${rego} (${state}) · Batteries to suit`;
        openVehicleTabBlank();
        showWidgetMessage(`We found your <strong>${label}</strong>, but couldn't match that make automatically. Please pick it from the <strong>Make</strong> list below – if it isn't there, <a href="${CONTACT_URL}">contact us</a> and we'll find the right battery for you.`, "info");
        return;
      }

      await Promise.all(makes.map(ensureMakeRows));
      const matches = findModelMatches(makes, v);

      const codesOf = m => (m.rows || []).map(r => r.fitmentCode).filter(Boolean).join(", ");
      // Do all of these options come down to the same battery?
      const codeKey = m => [...new Set((m.rows || []).flatMap(r =>
        String(r.fitmentCode || "").split(",").map(c => c.trim().toUpperCase()).filter(Boolean)))].sort().join("|");
      const sameBattery = ms => {
        const first = codeKey(ms[0]);
        return !!first && ms.every(m => codeKey(m) === first);
      };

      if (matches.length === 1) {
        // Exact vehicle found: fill Make / Model / Year and show the batteries (warnings appear in their own box)
        reportMatch(logRef, "matched", matches[0].make + " " + matches[0].model, codesOf(matches[0]), 1);
        askForVote(logRef);
        regoKicker = `Found from rego ${rego} (${state}) · ${v.year} ${v.make} ${v.model} · Batteries to suit`;
        await prefillVehicleTab(matches[0].make, [matches[0].model], matches[0].model, matches[0].year);
      } else if (matches.length > 1 && sameBattery(matches)) {
        // Several model names, one battery. Asking which variant they have would be a
        // question with only one answer, so show the batteries and leave the Model list
        // open in case they want to change it.
        pendingNotes = matches.flatMap(m => (m.rows || []).map(r => r.notes)).filter(Boolean);
        reportMatch(logRef, "matched", matches.map(m => m.model).join(" / "), codesOf(matches[0]), matches.length);
        askForVote(logRef);
        // Name the customer's own car, not one of the variants we didn't actually pick
        // between – otherwise a D300 owner is told we matched the 2.0.
        regoKicker = `Found from rego ${rego} (${state}) · Batteries to suit`;
        pendingLabel = [v.year, v.make, v.model].filter(Boolean).join(" ") + (v.grade ? ` ${v.grade}` : "");
        pendingModel = [String(v.model || "").trim(), String(v.grade || "").trim()].filter(Boolean).join(" ");
        pendingFitNote = sameBatteryNote(matches);
        await prefillVehicleTab(matches[0].make, matches.map(m => m.model), matches[0].model, matches[0].year);
      } else if (matches.length > 1) {
        reportMatch(logRef, "choose", matches.map(m => m.model).join(" | "), codesOf(matches[0]), matches.length);
        regoKicker = `Found from rego ${rego} (${state}) · Batteries to suit`;
        const names = [...new Set(matches.map(m => m.model))];
        if (names.length === 1) {
          // One model, more than one generation of it. The engine won't tell them apart,
          // but the build date will, so ask for that instead of the model.
          await prefillVehicleTab(matches[0].make, names, names[0]);
          if (!selectedValues.year) stepTo("year");
          showWidgetMessage(`We found your <strong>${label}</strong>! We list more than one build of this model and they don't take the same battery. Please choose the one covering your build date from the <strong>Year</strong> list – it's on the compliance plate under the bonnet.`, "info");
        } else {
          await prefillVehicleTab(matches[0].make, names);
          showWidgetMessage(`We found your <strong>${label}</strong>! Please choose your exact engine/variant from the <strong>Model</strong> list – your batteries will show straight away.`, "info");
        }
      } else if (v.likelyCar === false && !truckGuideOn()) {
        // Registered as a truck and nothing in the car guide fits it
        reportMatch(logRef, "not_a_car");
        reportEvent("no_results", "");
        showWidgetMessage(notInGuideMessage(v, label), "warning");
      } else {
        // We may well list this model and simply not for this year. Showing the whole make's
        // list buries that; showing just this model's entries makes the gap obvious and
        // leaves the customer one click from the nearest thing we do have.
        const sameName = [...new Set(nameOnlyHits.map(r => modelName(r)))].sort();
        // Those are two different jobs in the guide, so the portal is told which one it is:
        // a model nobody has written down, or one we list but not for the year they drive.
        // The rows we do have go with it - they are the ones whose years need extending.
        reportMatch(logRef, sameName.length ? "no_year" : "no_model",
                    sameName.join(" | "), "", sameName.length);
        reportEvent("no_results", "");
        await prefillVehicleTab((nameOnlyHits[0] && nameOnlyHits[0].make) || makes[0], sameName, "", "", true);
        if (sameName.length) {
          const named = escHtml(String(v.model || "").trim()) || "that model";
          showWidgetMessage(`We found your <strong>${label}</strong>. We list the ${named}, but nothing covering ${escHtml(String(v.year || "that year"))} – the <strong>Model</strong> list below now shows only our ${named} entries. Pick the closest, or <a href="${CONTACT_URL}">contact us</a> and we'll check it for you.`, "info");
        } else {
          showWidgetMessage(`We found your <strong>${label}</strong>, but couldn't match the exact model. Please choose it from the <strong>Model</strong> list.`, "info");
        }
      }
  }

  // Tell the Worker what we did with the result. The matching happens here in the browser,
  // so this is the only way the portal can flag the cars our guide is missing.
  // Best effort – a customer never sees it and it never holds anything up.
  // Staff replaying a past search. Nothing about a replay may reach the portal: it must not
  // land back in Gaps, in the usage log or in the sales figures.
  let replayMode = false;

  function reportMatch(ref, state, model, code, count) {
    if (!ref || replayMode) return;
    post("/match", { ref, state, model: model || "", code: code || "", count: count || 0 });
  }

  // "Did we get your vehicle right?" – only ever asked when the finder picked the vehicle
  // itself from a plate. If the customer chose the model from a list, the answer is their
  // own and tells us nothing about the guide.
  let voteRef = null;

  function askForVote(ref) {
    voteRef = (ref && !replayMode) ? ref : null;
  }

  function votedAlready(ref) {
    try { return sessionStorage.getItem("bwVote:" + ref) || ""; } catch (e) { return ""; }
  }

  function votedReason(ref) {
    try { return sessionStorage.getItem("bwVoteWhy:" + ref) || ""; } catch (e) { return ""; }
  }

  const VOTE_REASONS = [
    ["model", "Not my model"],
    ["engine", "Not my engine"],
    ["year", "Not my year"],
    ["other", "Something else"],
  ];

  function showVote() {
    const box = document.getElementById("bwr-vote");
    if (!box) return;
    const ref = voteRef;
    if (!ref) { box.style.display = "none"; box.innerHTML = ""; return; }

    const already = votedAlready(ref);
    if (already === "down" && !votedReason(ref)) { paintVoteReasons(box, ref); return; }
    if (already) { paintVoteThanks(box, already); return; }

    box.style.display = "flex";
    box.innerHTML =
      '<span><span class="bwr-vote-q" id="bwr-vote-q">Did we get your vehicle right?</span>' +
      '<span class="bwr-vote-why">One tap. It keeps our fitment guide honest.</span></span>' +
      '<span class="bwr-vote-btns">' +
        '<button type="button" class="bwr-vote-btn" data-vote="up" aria-label="Yes, this is my vehicle">' +
          '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 10v11H4a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1z"/><path d="M7 10l4.5-7a2 2 0 0 1 3.4 2l-1.4 5h5.1a2 2 0 0 1 2 2.5l-1.7 6.5a2 2 0 0 1-2 1.5H7z"/></svg>' +
          '<span>Yes</span>' +
        '</button>' +
        '<button type="button" class="bwr-vote-btn" data-vote="down" aria-label="No, this is not my vehicle">' +
          '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M17 14V3h3a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1z"/><path d="M17 14l-4.5 7a2 2 0 0 1-3.4-2l1.4-5H5.4a2 2 0 0 1-2-2.5l1.7-6.5a2 2 0 0 1 2-1.5H17z"/></svg>' +
          '<span>No</span>' +
        '</button>' +
      '</span>';

    box.querySelectorAll(".bwr-vote-btn").forEach(btn => {
      btn.addEventListener("click", () => castVote(ref, btn.getAttribute("data-vote")));
    });
  }

  function paintVoteThanks(box, vote) {
    box.style.display = "flex";
    box.innerHTML = vote === "up"
      ? '<span class="bwr-vote-q">Thanks – good to know we got it right.</span>'
      : '<span><span class="bwr-vote-q">Thanks, we\'ll take a look at this one.</span>' +
        '<span class="bwr-vote-why">Sorry about that. Start again below, or give us a call and we\'ll find the right one.</span></span>' +
        '<button type="button" class="bwr-vote-again">Search again <span class="bwr-arrow" aria-hidden="true">&rarr;</span></button>';
    const again = box.querySelector(".bwr-vote-again");
    if (again) again.addEventListener("click", () => clearSearch());
  }

  function castVote(ref, vote) {
    if (vote !== "up" && vote !== "down") return;
    try { sessionStorage.setItem("bwVote:" + ref, vote); } catch (e) { /* the vote still sends */ }
    // The vote goes first and on its own. Whatever happens next - they pick a reason, they
    // close the tab - the thumbs-down is already recorded.
    if (!replayMode) post("/feedback", { ref, vote });
    const box = document.getElementById("bwr-vote");
    if (!box) return;
    if (vote === "down") paintVoteReasons(box, ref);
    else paintVoteThanks(box, vote);
  }

  // A thumbs-down says something was wrong but not what, and the difference between a
  // wrong engine and a wrong year is the difference between two jobs in the guide.
  function paintVoteReasons(box, ref) {
    box.style.display = "flex";
    box.innerHTML =
      '<span><span class="bwr-vote-q">Thanks &ndash; what was wrong?</span>' +
      '<span class="bwr-vote-why">One more tap and we can put it right.</span></span>' +
      '<span class="bwr-reasons">' +
        VOTE_REASONS.map(function (r) {
          return '<button type="button" class="bwr-reason" data-reason="' + r[0] + '">' + escHtml(r[1]) + '</button>';
        }).join("") +
      '</span>';
    box.querySelectorAll(".bwr-reason").forEach(btn => {
      btn.addEventListener("click", () => sendVoteReason(ref, btn.getAttribute("data-reason")));
    });
  }

  function sendVoteReason(ref, reason) {
    if (!VOTE_REASONS.some(r => r[0] === reason)) return;
    try { sessionStorage.setItem("bwVoteWhy:" + ref, reason); } catch (e) { /* it still sends */ }
    if (!replayMode) post("/feedback", { ref, vote: "down", reason });
    const box = document.getElementById("bwr-vote");
    if (box) paintVoteThanks(box, "down");
  }

  // How the current results were found, so the portal can compare a paid rego lookup
  // against a free Make/Model/Year search or a saved vehicle
  let searchKind = "manual";
  let searchRef = null;
  let searchId = null;          // one id per search, so three batteries added is still one sale

  const newSearchId = () => Math.random().toString(36).slice(2, 10) + Date.now().toString(36);

  // Batteries shown / battery added to cart. Counts only – no customer or cart details.
  function reportEvent(step, code, qty) {
    if (step === "results" || step === "no_results") searchId = newSearchId();
    if (replayMode) return;
    post("/event", { kind: searchKind, step, ref: searchRef || "", sid: searchId || "", code: code || "", qty: qty || 0 });
  }

  // Stamp the search onto the cart so the order carries it. Shopify keeps attributes whose
  // name starts with "_" out of the customer's way but still saves them on the order, which
  // is what lets us see later which searches turned into a sale.
  function tagCart() {
    if (!searchId || replayMode) return;
    try {
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ attributes: { _battery_finder: searchId + "|" + (searchRef || "") + "|" + searchKind } }),
        cache: "no-store"
      }).catch(() => {});
    } catch (e) { /* never blocks the customer */ }
  }

  function post(path, body) {
    try {
      fetch(CLOUDFLARE_WORKER_URL.replace(/\/+$/, "") + path, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body), keepalive: true, cache: "no-store"
      }).catch(() => {});
    } catch (e) { /* never blocks the customer */ }
  }

  function notInGuideMessage(v, label) {
    return (v && v.likelyCar === false && !truckGuideOn())
      ? `We found your <strong>${label}</strong>, but it's registered as a commercial vehicle and isn't in our car guide. Truck searches are coming soon – please contact us and we'll find the right battery for you.`
      : `We found your <strong>${label}</strong>, but it isn't in our battery guide yet. Please contact us and we'll help you find the right battery.`;
  }

  // Switch to the Vehicle tab with nothing chosen yet, just the full make list
  function openVehicleTabBlank() {
    const vehicleTabBtn = document.querySelectorAll('.bw-tab-link')[1];
    if (vehicleTabBtn) openSearchTab({ currentTarget: vehicleTabBtn }, 'tab-vehicle');
    populateMakes();
  }

  // Switch to the Vehicle tab with make (and optionally model/year) filled in
  // A plate searched under Truck & bus has to arrive on the Make, Model, Year tab with
  // Truck & bus still showing. Left on Car, the buttons contradict the result above them
  // and the Make list is drawn from the wrong guide.
  function syncGuideButtons() {
    if (!guideOpen(pickedGuide)) { pickedGuide = "car"; }
    document.querySelectorAll('input[name="vtype"]').forEach(r => {
      r.checked = r.value === pickedGuide;
    });
  }

  async function prefillVehicleTab(make, modelList, model, year, narrowToList) {
    const vehicleTabBtn = document.querySelectorAll('.bw-tab-link')[1];
    if (vehicleTabBtn) openSearchTab({ currentTarget: vehicleTabBtn }, 'tab-vehicle');
    syncGuideButtons();
    populateMakes();
    await selectOption('make', make);
    if (modelList.length > 1 || (narrowToList && modelList.length)) {
      optionsData.model = [...modelList].sort();
      renderCustomList("model", optionsData.model);
    }
    if (model) {
      selectOption('model', model);                                   // auto-picks the year if there's only one
      // A model with no years of its own has already searched itself by this point
      if (year && optionsData.year.length && selectedValues.year !== year) selectOption('year', year);
    }
  }

  /* ---------- tabs & messages ---------- */
  function openSearchTab(evt, tabName) {
    hideWidgetMessage();
    closeAllDropdowns();
    if (tabName === "tab-rego") resetRegoType();
    const content = document.getElementsByClassName("bw-tab-content");
    for (let i = 0; i < content.length; i++) { content[i].classList.remove("active-content"); content[i].style.display = "none"; }
    const links = document.getElementsByClassName("bw-tab-link");
    for (let i = 0; i < links.length; i++) links[i].classList.remove("active");
    const activeTab = document.getElementById(tabName);
    activeTab.style.display = "block";
    setTimeout(() => { activeTab.classList.add("active-content"); }, 10);
    // Marks the tab button for this panel, so a "search another way" link elsewhere on the
    // page can call this without the link itself becoming the active tab
    const want = tabName === "tab-vehicle" ? 1 : 0;
    const onTab = evt && evt.currentTarget && evt.currentTarget.classList.contains("bw-tab-link");
    const mark = onTab ? evt.currentTarget : links[want];
    if (mark) mark.classList.add("active");
    if (!onTab && mark && typeof mark.focus === "function") mark.focus();
  }

  function showWidgetMessage(msg, type = "warning") {
    const banner = document.getElementById("bw-status-banner");
    if (!banner) return;
    banner.className = `bw-status-box bw-status-${type}`;
    banner.innerHTML = `<span>${msg}</span><button class="bw-status-close" onclick="hideWidgetMessage()">&times;</button>`;
    banner.style.display = "flex";
  }

  function hideWidgetMessage() {
    const banner = document.getElementById("bw-status-banner");
    if (banner) banner.style.display = "none";
  }

  // Started from the very bottom of the file so every variable above has been created,
  // whether the script lands before the page is ready or long after it.
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", bwInit);
  else bwInit();